<template>
  <div id="containtSales">
    <div class="grid md:grid-cols-12 gap-6">
      <div class="md:col-span-8 xl:col-span-9 relative" ref="salesMainPanel">
        <div class="flex flex-wrap gap-4 mb-3">
          <button
            class="px-2 py-1 bg-blue-100 text-blue-500 font-semibold text-xs rounded-md active:scale-95 items-center flex hover:bg-blue-500 hover:text-white"
            @click="showAddProduct">
            <font-awesome-icon icon="fa-solid fa-store" class="mr-1" />
            Productos
          </button>
          <button
            class="px-2 py-1 bg-green-100 text-green-700 font-semibold text-xs rounded-md active:scale-95 hover:bg-green-500 hover:text-white"
            @click="showAppDelivery">
            <font-awesome-icon icon="fa-solid fa-truck" class="mr-1" /> Delivery
          </button>
          <button
            class="px-2 py-1 bg-blue-100 text-blue-500 font-semibold text-xs rounded-md active:scale-95 hover:bg-blue-500 hover:text-white"
            @click="showInsurer" v-show="stateAccesInsurer">
            <font-awesome-icon icon="fa-solid fa-building" class="mr-1" />
            Aseguradoras
          </button>
          <button
            class="px-2 py-1 bg-gray-100 text-gray-600 font-semibold text-xs rounded-md active:scale-95 hover:bg-gray-500 hover:text-white"
            @click="showCreditNote">
            <font-awesome-icon icon="fa-solid fa-file" class="mr-1" />
            Nota de crédito
          </button>
          <button
            class="px-2 py-1 bg-blue-100 text-blue-500 font-semibold text-xs rounded-md active:scale-95 items-center flex hover:bg-blue-500 hover:text-white"
            @click="showSalesHold">
            <font-awesome-icon icon="fa-solid fa-cart-shopping" class="mr-1" />
            Factura Hold
          </button>
          <button
            class="px-2 py-1 bg-orange-100 text-orange-600 font-semibold text-xs rounded-md active:scale-95 hover:bg-orange-500 hover:text-white"
            @click="showTemporarySales">
            <font-awesome-icon icon="fa-solid fa-computer-mouse" class="mr-1" />
            Ventas temporales
          </button>
          <button
            class="px-2 py-1 bg-blue-100 text-blue-500 font-semibold text-xs rounded-md active:scale-95 hover:bg-blue-500 hover:text-white"
            @click="showQuotes">
            <font-awesome-icon icon="fa-solid fa-folder-open" class="mr-1" />
            Cotizaciones
          </button>
          <button
            class="px-2 py-1 bg-green-600 text-white font-semibold text-xs rounded-md active:scale-95 hover:bg-green-700 disabled:opacity-50 disabled:cursor-not-allowed"
            @click="openPurchaseHistory" :disabled="!infoCustomer.id || infoCustomer.id === 0"
            title="Historial de compras">
            <font-awesome-icon icon="fa-solid fa-clock" class="mr-1" />
            Historial
          </button>
          <button
            class="px-2 py-1 bg-emerald-100 text-emerald-700 font-semibold text-xs rounded-md active:scale-95 hover:bg-emerald-600 hover:text-white"
            @click="showWorkshopEquipments" v-if="stateAccesWorkshopEquipments">
            <font-awesome-icon icon="fa-solid fa-screwdriver-wrench" class="mr-1" />
            Equipos
          </button>
        </div>
        <div class="mb-3">
          <SearchCustomer :key="customerSearchKey" @send-data="getDataCustomer" :stateInfo="stateShowInfoCustomer"
            :initialCustomerName="workshopCustomerName" :initialCustomerData="prefilledCustomerData" />
        </div>
        <div class="bg-blue-50 px-3 rounded-md py-3 mb-3" v-if="stateTemporarySales">
          <SearchTemporarySales @send-data="getOrder" />
        </div>
        <div class="bg-blue-50 px-3 rounded-md py-3 mb-3" v-if="stateQuotes">
          <SearchQuotes @send-data="getOrder" />
        </div>
        <div class="bg-blue-50 px-3 rounded-md py-3 mb-3" v-if="stateSalesHold">
          <SearchSalesHold @send-data="getOrder" />
        </div>
        <div class="bg-blue-50 px-3 rounded-md py-3 mb-3" v-if="stateAppDelivery">
          <SearchAppDelivery @send-data="getDataAppDelivery" />
        </div>
        <div class="bg-blue-50 px-3 rounded-md py-3 mb-3" v-if="stateInsurer">
          <SearchInsurer @send-data="getInsurer" />
        </div>
        <div class="bg-blue-50 px-3 rounded-md py-3 mb-3" v-if="stateCreditNote">
          <SearchCreditNote @send-data="getCreditNote" />
        </div>
        <div>
          <div class="py-3 bg-blue-50 px-3 rounded-md grid md:grid-cols-12 gap-4">
            <SearchProduct @send-data="addProducts" :typeVoucher="nameVoucher"
              :sellWithCustomer="infoCustomer.sell_with" />
            <div class="col-span-3 flex flex-wrap items-center justify-start md:justify-end gap-2">
              <div v-if="searchedProductLocation"
                class="location-badge w-auto max-w-[150px] sm:max-w-[180px] md:max-w-[200px] px-2.5 py-1.5 rounded-md bg-white text-sky-700 text-[11px] font-semibold border border-sky-200 uppercase truncate shadow-sm leading-none"
                :title="searchedProductLocation">
                Ubicacion: {{ searchedProductLocation }}
              </div>
              <button
                class="bg-red-100 rounded-md text-red-600 text-sm px-3 py-1 h-full font-semibold hover:bg-red-500 hover:text-white active:scale-95"
                @click="saveTemporarySales">
                TEMP
              </button>
            </div>
          </div>
          <!-- detalle de la orden de compra -->
          <div
            class="overflow-x-auto overflow-y-auto table-d md:max-w-full max-h-[55vh] md:max-h-[calc(100vh-210px)] min-h-0 md:min-h-[calc(100vh-470px)]">
            <table class="table-auto w-full">
              <TableHead :headers="header" class="sticky top-0 [&>tr>th]:text-[12px]" />
              <LoadingTables v-if="loading" :columns="9" />
              <tbody class="text-gray-500 text-left border-t-[1px]" v-else id="dataTable">
                <tr
                  class="hover:bg-blue-500 transition-colors hover:text-white capitalize font-semibold odd:bg-white even:bg-slate-50 td-focus"
                  v-for="(product, i) in arrayOfProducts" :key="i">
                  <td class="border-slate-200 text-xs px-6 py-2 whitespace-nowrap"
                    :class="stateAccesCheck ? 'table-cell' : 'hidden'">
                    <input type="checkbox" class="cursor-pointer w-4 h-4" @change="selectProduct(product)" />
                  </td>
                  <td class="border-slate-200 text-xs px-6 py-2 whitespace-nowrap">
                    <div>{{ product.productName }}</div>
                    <div v-if="product.isWorkshopOrder" class="mt-1 flex flex-wrap gap-1">
                      <span
                        class="px-2 py-0.5 rounded-md bg-emerald-50 text-emerald-700 text-[10px] font-semibold uppercase">
                        Taller
                      </span>
                      <span
                        class="px-2 py-0.5 rounded-md bg-slate-100 text-slate-600 text-[10px] font-semibold uppercase">
                        {{ product.workshopOrderCode || 'Orden Taller' }}
                      </span>
                    </div>
                    <div v-if="product.appliedPromotions?.length > 0 || Number(product.bonusQuantity || 0) > 0"
                      class="mt-1 flex flex-wrap gap-1">
                      <span v-for="(promotion, promotionIndex) in product.appliedPromotions"
                        :key="`${i}-${promotionIndex}`"
                        class="px-2 py-0.5 rounded-md bg-blue-50 text-blue-600 text-[10px] font-semibold uppercase">
                        {{ promotion.name }}
                      </span>
                      <span v-if="Number(product.bonusQuantity || 0) > 0"
                        class="px-2 py-0.5 rounded-md bg-emerald-50 text-emerald-600 text-[10px] font-semibold uppercase">
                        Promocion 1
                      </span>
                    </div>
                  </td>
                  <td class="border-slate-200 text-xs px-6 py-2 whitespace-nowrap uppercase">
                    <input type="number" min="1" :value="product.quantity"
                      class="bg-white text-gray-500 outline-blue-500 py-1 px-1 max-w-[45px] rounded-md border-2 border-blue-100 text-center disabled:bg-slate-100 disabled:text-slate-400"
                      :disabled="product.isWorkshopOrder" @blur="
                        handleQuantityChange(i, $event, product.igvApplied)
                        " @keyup.enter="
                          handleQuantityChange(i, $event, product.igvApplied)
                          " />
                  </td>
                  <td class="border-slate-200 text-xs px-6 py-2 whitespace-nowrap uppercase">
                    <select
                      class="border-2 bg-gray-50 py-1 text-xs px-3 text-gray-600 cursor-pointer rounded-lg mr-3 font-semibold max-w-[120px] focus:outline-double focus:outline-2 focus:outline-blue-500 disabled:cursor-not-allowed disabled:bg-slate-100 disabled:text-slate-400"
                      :disabled="product.isWorkshopOrder" @change="
                        handleUnitMeasureChange(i, $event, product.igvApplied)
                        ">
                      <option :value="unit.precio +
                        '|' +
                        (unit.factor_stock ?? (parseFloat(unit.cantidad) > 0 ? 1 / parseFloat(unit.cantidad) : 1)) +
                        '|' +
                        unit.unidad_de_medida
                        " v-for="(unit, index) in product.units" :key="index" :selected="unit.unidad_de_medida === product.unitMeasure
                          ">
                        {{ unit.unidad_de_medida }}
                      </option>
                    </select>
                  </td>
                  <td class="border-slate-200 text-xs px-6 py-2 whitespace-nowrap uppercase">
                    <select @blur="handlePrices(i, $event, product)" @input="handlePrices(i, $event, product)"
                      class="border-2 bg-gray-50 py-1 text-xs px-3 text-gray-600 cursor-pointer rounded-lg mr-3 font-semibold focus:outline-double focus:outline-2 focus:outline-blue-500 disabled:cursor-not-allowed disabled:bg-slate-100 disabled:text-slate-400"
                      :disabled="product.isWorkshopOrder" v-model="product.priceSelectedForTheCustomer">
                      <option value="1" selected>PRECIO 1</option>
                      <option value="2" v-if="product.showBTNPriceTwo && usePriceTwo">
                        PRECIO 2
                      </option>
                      <option value="3" v-if="product.showBTNPriceThree && usePriceThree">
                        PRECIO 3
                      </option>
                    </select>
                  </td>
                  <td class="border-slate-200 text-xs px-6 py-2 whitespace-nowrap uppercase">
                    <!--{{ money() }} {{ format(product.salePrice) }}-->
                    <div v-if="!stateModifiPrice || product.isWorkshopOrder">
                      <span>{{ money() }} {{ format(product.salePrice) }}</span>
                      <div v-if="Number(product.baseSalePrice || product.salePrice) > Number(product.salePrice)"
                        class="text-[10px] text-slate-400 line-through">
                        {{ money() }} {{ format(product.baseSalePrice) }}
                      </div>
                    </div>
                    <input v-else type="number" min="1" :value="product.salePrice"
                      class="bg-white text-orange-500 outline-none py-1 px-1 text-xs max-w-[70px] rounded-md border-2 border-blue-100 text-center"
                      @blur="
                        handleUnitPriceChange(
                          i,
                          $event,
                          product.igvApplied,
                          product.shoppingPrice,
                          product.salePrice
                        )
                        " @keyup.enter="
                          handleUnitPriceChange(
                            i,
                            $event,
                            product.igvApplied,
                            product.shoppingPrice,
                            product.salePrice
                          )
                          " />
                  </td>
                  <td class="border-slate-200 text-xs px-6 py-2 whitespace-nowrap uppercase font-bold">
                    {{ money() }} {{ format(product.total) }}
                  </td>
                  <!-- <td
                    class="border-slate-200 text-sm px-6 py-2 whitespace-nowrap uppercase"
                  >
                    <input
                      type="number"
                      min="1"
                      :value="product.discount"
                      class="bg-white text-gray-500 outline-none py-1 px-1 max-w-[45px] rounded-md border-2 border-blue-100 text-center"
                      @blur="
                        handleDiscountChange(i, $event, product.igvApplied)
                      "
                      @keyup.enter="
                        handleDiscountChange(i, $event, product.igvApplied)
                      "
                    />
                  </td> -->
                  <td class="border-slate-200 text-xs px-6 py-2 whitespace-nowrap uppercase"
                    :class="{ 'w-0 hidden': !stateAccesInsurer }">
                    <input type="number" min="1" :value="product.insuranceDiscount"
                      class="bg-white text-gray-500 outline-none py-1 px-1 max-w-[45px] rounded-md border-2 border-blue-100 text-center disabled:bg-slate-100 disabled:text-slate-400"
                      :disabled="product.isWorkshopOrder" @blur="handleInsuranceDiscountChange(i, $event)"
                      @keyup.enter="handleInsuranceDiscountChange(i, $event)" />
                  </td>
                  <!-- <td
                    class="border-slate-200 text-sm px-6 py-2 whitespace-nowrap uppercase"
                  >
                    <span
                      v-if="
                        calculateOffertExpired(
                          product.vencimiento_descuento
                        ) === true
                      "
                    ></span>
                    <input
                      v-else
                      type="checkbox"
                      class="bg-white text-gray-500 outline-none py-1 px-1 max-w-[45px] rounded-md border-2 border-blue-100 text-center"
                      @change="
                        handlePriceForDiscount(i, $event, product.igvApplied)
                      "
                    />
                  </td> -->
                  <td class="border-slate-200 text-xs px-6 py-2 whitespace-nowrap uppercase"
                    :class="stateAccesPSerie ? 'table-cell' : 'hidden'">
                    <input type="text" :value="product.productSerie"
                      class="bg-white text-gray-500 outline-none py-1 px-1 rounded-md border-2 border-blue-100 text-center disabled:bg-slate-100 disabled:text-slate-400"
                      :disabled="product.isWorkshopOrder" @blur="handleProductSerie(i, $event)" />
                  </td>
                  <td class="border-slate-200 text-sm px-6 py-2 text-right whitespace-nowrap">
                    <div class="flex justify-end">
                      <button
                        class="bg-red-100 text-red-500 hover:text-white p-2 w-8 h-8 text-sm active:scale-105 hover:bg-red-500 flex items-center justify-center rounded-md"
                        @click="deleteRecordFromTable(i)">
                        <font-awesome-icon icon="fa-solid fa-trash" class="w-3 h-3" />
                      </button>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div>
          <ComponentForTotalDetails :iva="dataForm.igv" :subTotal="dataForm.subTotal" :total="dataForm.total"
            :otherDiscounts="dataForm.otherDiscounts" :totalCreditNote="dataForm.totalCreditNote"
            :totalCreditNoteDiference="dataForm.totalCreditNoteDiference"
            :totalWhitDiscount="dataForm.totalWhitDiscount" :totalPayableByCustomer="dataForm.totalPayableByCustomer"
            :totalPayableByInsurer="dataForm.totalPayableByInsurer" :insurerBussinesName="infoInsurer.bussinesName" />
        </div>
        <div class="px-3 py-3 rounded-md bg-blue-50 border border-blue-100 mt-3 md:grid md:grid-cols-2 md:gap-4"
          v-show="stateForCreditToSale">
          <label class="block">
            <span class="block mb-2 text-sm font-medium text-blue-500 dark:text-white">
              Abono inicial
            </span>
            <input type="number"
              class="py-2 px-2 text-sm bg-gray-50 outline-none rounded-lg text-gray-600 w-full border-2 focus:border-blue-500 resize-none"
              v-model="dataForm.initialFee" placeholder="Abono inicial..." @keydown.enter.prevent min="0" />
          </label>
          <label class="block">
            <span class="block mb-2 text-sm font-medium text-blue-500 dark:text-white">
              Fecha de pago
            </span>
            <input type="date"
              class="py-2 px-2 text-sm bg-gray-50 outline-none rounded-lg text-gray-600 w-full border-2 focus:border-blue-500 resize-none"
              v-model="dataForm.paymentDate" @keydown.enter.prevent />
          </label>
        </div>

        <CustomerPurchaseHistoryModal v-if="statePurchaseHistoryModal" :onClose="closePurchaseHistory"
          :customerName="infoCustomer.fullName" :sales="purchaseHistorySales" :loading="purchaseHistoryLoading"
          :error="purchaseHistoryError" :containerEl="salesMainPanel" />
      </div>
      <div
        class="md:col-span-4 xl:col-span-3 px-3 py-3 pb-24 md:pb-3 rounded-md border-2 shadow-md shadow-blue-100 border-blue-50 space-y-4 bg-white/95">
        <div class="md:max-h-[45vh] 2xl:max-h-full overflow-y-auto md:pb-10 pr-2 2xl:p-0 scroll-options-sales">
          <div class="px-4 py-2 bg-blue-500 text-white text-2xl font-semibold text-center rounded-md">
            {{ money() }} {{ format(dataForm.totalWhitDiscount) }}
          </div>
          <!-- lista de comprobante -->
          <label class="block w-full mt-4">
            <span class="block mb-2 text-sm font-medium text-gray-800 dark:text-white">
              Comprobante de venta
            </span>
            <VouchersOfSale @send-data="getSelectVouchersOfSale" :selectOption="typeVoucher"
              :selectOptionForCustomer="infoCustomer.fixed_voucher" :key="changeVoucher" />
          </label>
          <!-- lista de tipo de ventas -->
          <label class="block w-full">
            <span class="block mb-2 text-sm font-medium text-gray-800 dark:text-white">
              Tipo de venta
            </span>
            <TypeOfSale :selectOption="dataForm.idTypeOfSale" @send-data="getSelectTypeOfSale"
              :key="counterKeyTypeOfSale" />
          </label>
          <!-- lista de tipos de pagos -->
          <label class="block w-full">
            <span class="block mb-2 text-sm font-medium text-gray-800 dark:text-white">
              Tipo de pago
            </span>
            <TypeOfPayment :selectOption="dataForm.idTypeOfPayment" @send-data="getSelectTypeOfPayment"
              :key="counterKeyTypeOfPayment" />
          </label>
          <!-- numero de operación o transacción -->
          <label class="block" v-show="stateForPaymentType">
            <span class="block mb-2 text-sm font-medium text-gray-800 dark:text-white">
              N° de operación
            </span>
            <input type="text"
              class="py-2 px-2 text-sm bg-gray-50 outline-none rounded-lg text-gray-600 w-full border-2 focus:border-blue-500 resize-none"
              v-model="dataForm.numberOperation" placeholder="N° de operación..." @keydown.enter.prevent
              maxlength="30" />
          </label>

          <!-- descripción entidad bancaria -->
          <label class="block" v-show="stateForPaymentType">
            <span class="block mb-2 text-sm font-medium text-gray-800 dark:text-white">
              Entidad bancaria
            </span>
            <input type="text"
              class="py-2 px-2 text-sm bg-gray-50 outline-none rounded-lg text-gray-600 w-full border-2 focus:border-blue-500 resize-none"
              v-model="dataForm.entityBank" placeholder="Entidad bancaria..." @keydown.enter.prevent maxlength="60" />
          </label>
          <!-- validez de cotización -->
          <label class="block" v-show="stateForQuotation">
            <span class="block mb-2 text-sm font-medium text-gray-800 dark:text-white">
              Validez de cotización
            </span>
            <input type="date"
              class="py-2 px-2 text-sm bg-gray-50 outline-none rounded-lg text-gray-600 w-full border-2 focus:border-blue-500 resize-none"
              v-model="dataForm.expireQuotation" @keydown.enter.prevent />
          </label>
          <!-- Comentario adicional -->
          <label class="block">
            <span class="block mb-2 text-sm font-medium text-gray-800 dark:text-white">
              Comentario adicional
            </span>
            <textarea name="" id="" cols="30" rows="2"
              class="py-2 px-2 text-sm bg-gray-50 outline-none rounded-lg text-gray-600 w-full border-2 focus:border-blue-500 resize-none"
              v-model="dataForm.comentary" placeholder="Comentario adicional..." maxlength="100"></textarea>
          </label>

          <label class="block">
            <span class="block mb-2 text-sm font-medium text-gray-800 dark:text-white">
              Código de pedido
            </span>
            <input type="text"
              class="py-2 px-2 text-sm bg-gray-50 outline-none rounded-lg text-gray-600 w-full border-2 focus:border-blue-500 resize-none"
              v-model="dataForm.codigo_pedido" placeholder="Código de pedido..." @keydown.enter.prevent
              maxlength="60" />
          </label>
          <!-- Descuento para el usuario -->
          <label class="block">
            <span class="block mb-2 text-sm font-medium text-gray-800 dark:text-white">
              Descuento
            </span>
            <input type="number"
              class="py-2 px-2 text-sm bg-gray-50 outline-none rounded-lg text-gray-600 w-full border-2 focus:border-blue-500 resize-none"
              v-model="dataForm.discount" placeholder="Comentario adicional..." @keydown.enter.prevent
              v-if="!salesDiscountStatus" :readonly="!salesDiscountStatus"
              @click="showValidateUserAccess('REALIZAR DESCUENTOS EN VENTA')" id="discountSale" />
            <input type="number"
              class="py-2 px-2 text-sm bg-gray-50 outline-none rounded-lg text-gray-600 w-full border-2 focus:border-blue-500 resize-none"
              v-model="dataForm.discount" placeholder="Descuento global..." @keydown.enter.prevent
              v-if="salesDiscountStatus" @input="applyDiscountToSale" />
          </label>
          <label class="block w-full mt-4">
            <span class="block mb-2 text-sm font-medium text-gray-800 dark:text-white">
              Mensajero
            </span>
            <SearchUserCharge @send-data="handeCharge" />
          </label>
        </div>
        <div class="px-3 py-3 rounded-md border-2 border-blue-100 bg-blue-100 grid gap-4"
          v-show="stateInputsThePayment">
          <!-- Importe de pago del cliente -->
          <label class="block">
            <span class="block mb-2 text-sm font-medium text-blue-500 dark:text-white">
              IMPORTE DE PAGO
            </span>
            <input type="number"
              class="py-2 px-2 text-sm bg-gray-50 border-blue-500 outline-none rounded-lg text-gray-600 w-full border-2 focus:border-blue-500 resize-none"
              v-model="dataForm.customerAmountPaid" placeholder="Importe del cliente" @keydown.enter.prevent
              @input="calculteCustomerAmountReturned" @click="dataForm.customerAmountPaid = ''" id="import_payments"
              title="ALT + D" />
          </label>
          <!-- Monto de vuelto que recivira el cliente -->
          <label class="block">
            <span class="block mb-2 text-sm font-medium text-blue-500 dark:text-white">
              DEVUELTA
            </span>
            <input type="number"
              class="py-2 px-2 text-sm bg-blue-200 border-blue-200 outline-none rounded-md text-blue-600 w-full border-2 resize-none font-bold"
              v-model="dataForm.customerAmountReturned" placeholder="Devuelta" @keydown.enter.prevent readonly />
          </label>
        </div>
        <div
          class="sticky bottom-3 z-20 rounded-xl border border-slate-200 bg-white/95 p-2 shadow-xl backdrop-blur supports-[backdrop-filter]:bg-white/90">
          <div class="flex justify-between gap-3">
            <button
              class="bg-red-50 text-red-500 px-3 py-3 font-semibold text-xs rounded-lg hover:shadow-sm active:scale-95 flex items-center justify-center w-22 hover:bg-red-500 hover:text-white"
              @click="cancelSale" title="ALT + X">
              <font-awesome-icon icon="fa-solid fa-cancel" class="mr-2" />
              <span>Cancelar</span>
            </button>
            <button
              class="bg-blue-500 text-white px-3 py-3 font-semibold text-xs rounded-lg hover:shadow-sm hover:shadow-blue-600 active:scale-95 flex items-center w-full justify-center"
              @click="insert" :disabled="spinner === true" title="ALT + S">
              <div class="flex items-center" v-if="spinner">
                <svg class="w-4 h-4 mr-3 animate-spin">
                  <use href="../../assets/svg/icon.svg#spinnerForBlue" />
                </svg>
                {{ primaryActionLoadingLabel }}
              </div>
              <span v-else>{{ primaryActionLabel }}</span>
            </button>
          </div>
          <div class="w-full pt-2 text-xs text-center text-blue-500 font-semibold cursor-pointer"
            @click="showModalProductsOutStock" v-if="productsOutOfStock.length > 0">
            <span class="border-b mx-auto border-b-blue-500">ver productos con error</span>
          </div>
        </div>
      </div>
    </div>
    <AddProduct @send-data="getAmountAgreed" v-if="stateAddProduct" :activeModal="showAddProduct" />
    <ValidateUserAccess v-if="stateShowUserAccess" :activeModal="showValidateUserAccess" :area="area"
      @send-data="validateAccess" />
    <CombinedPayments :activeModal="showCombinedPayments" @send-data="getCombinedPayment"
      :amount="dataForm.totalWhitDiscount" v-if="stateShowCombinedPayment" />
    <ShowProductsOutStock :showModal="showModalProductsOutStock" :details="productsOutOfStock"
      v-if="isShowModalProductsOutStock" />
    <WorkshopOrderSaleLoader v-if="stateWorkshopEquipments" @send-data="applyWorkshopOrderSelection"
      @close="closeWorkshopEquipments" />

  </div>
</template>

<script>
import SearchCustomer from "./Searchs/SearchCustomer.vue";
import SearchTemporarySales from "./Searchs/SearchTemporarySales.vue";
import SearchProduct from "./Searchs/SearchProduct.vue"; // Public components
import SearchSalesHold from "./Searchs/SearchSalesHold.vue";
import SearchAppDelivery from "./Searchs/SearchAppDelivery.vue";
import SearchInsurer from "./Searchs/SearchInsurer.vue";
import SearchQuotes from "./Searchs/SearchQuotes.vue";
import SearchCreditNote from "./Searchs/SearchCreditNote.vue";
import WorkshopOrderSaleLoader from "@/components/Workshop/WorkshopOrderSaleLoader.vue";
// Public components
import TypeOfPayment from "@/components/PublicComponents/TypeOfPayment.vue";
import TypeOfSale from "@/components/PublicComponents/TypeOfSale.vue";
import VouchersOfSale from "@/components/PublicComponents/VouchersOfSale.vue";
import ComponentForTotalDetails from "./Details/ComponentForTotalDetails.vue";
import { computed, nextTick, onMounted, onUnmounted, ref, watch } from "vue";
import { observeElement } from "@/observer";
import LoadingTables from "@/components/Loadings/LoadingTables";
import TableHead from "@/components/TablesComponents/TableHead";
import { money, format } from "@/publicjs/money";
import { percentage } from "@/publicjs/convertToPercentage";
import { errorActions, notificationAction } from "@/alerts";
import axios from "@/api";
import AddProduct from "@/components/Sales/AddProductsToStore/AddProduct.vue";
import ValidateUserAccess from "@/components/ValidateUserAccess/ValidateUserAccess.vue";
import CombinedPayments from "@/components/Sales/CombinedPayments/CombinedPayments.vue";
import { insertSale } from "@/repository/Sales/Main/InsertSale";
import { insertCustomerOrder } from "@/repository/Sales/Main/InsertCustomerOrder";
import { insertQuotes } from "@/repository/Sales/Main/InsertQuotes";
import { insertTemporarySale } from "@/repository/Sales/Main/InsertTemporarySale";
import SearchUserCharge from "./Searchs/SearchUserCharge.vue";
import ShowProductsOutStock from "@/components/Sales/ShowProductsOutStock.vue";
import CustomerPurchaseHistoryModal from "@/components/Sales/Modals/CustomerPurchaseHistoryModal.vue";

import {
  referenceNumber,
  updateNumberVoucher,
  updateReferenceNumber,
  voucherSales,
} from "@/publicjs/vouchers";
import {
  idLocalStore,
  idLocalTurn,
  idLocalUser,
  localIVA,
  localMoney,
  localUserName,
} from "@/publicjs/localStorage";

// Print voucher
import { printVoucherOnA4 } from "./PrintVoucher/PrintOnA4";
import { printVoucherOnLetter } from "./PrintVoucher/PrintOnLetter";
import { printVoucherOnMediaLetter } from "./PrintVoucher/PrintOnMediaLetter";
import { printVoucherTicket } from "./PrintVoucher/PrintOnTicket";

//Impresion de comprobantes para cortizaciones
import { printOnA4 } from "@/components/Quotes/PrintVoucher/PrintOnA4";
import { printOnLetter } from "@/components/Quotes/PrintVoucher/PrintOnLetter";
import { printOnMediaLetter } from "@/components/Quotes/PrintVoucher/PrintOnMediaLetter";
import { printOnTicket } from "@/components/Quotes/PrintVoucher/PrintOnTicket";
import calculateOffertExpired from "@/publicjs/calculateOffertExpired";
//Importacion para validar acceso del usuario
import { validateAccessSpecific } from "@/repository/Sales/ValidateAccessEspecific/ValidateAccess";
import columsHidden from "@/publicjs/columsHidden";
import calculatePaymentDate from "@/publicjs/calculatePaymentDate";
import VerifyStocks from "@/repository/VerifyProducts/VerifyStocks";
import {
  fetchProductPromotions,
  resolveSalePromotions,
} from "@/repository/Promotions/PromotionsRepository";
export default {
  name: "MainSales",
  components: {
    SearchCustomer,
    SearchTemporarySales,
    SearchProduct,
    SearchSalesHold,
    SearchAppDelivery,
    SearchInsurer,
    SearchQuotes,
    SearchCreditNote,
    WorkshopOrderSaleLoader,
    TypeOfPayment,
    TypeOfSale,
    VouchersOfSale,
    ComponentForTotalDetails,
    LoadingTables,
    TableHead,
    AddProduct,
    ValidateUserAccess,
    CombinedPayments,
    SearchUserCharge,
    ShowProductsOutStock,
    CustomerPurchaseHistoryModal,
  },
  setup() {
    const salesMainPanel = ref(null);
    const normalizeVoucherName = (value) => String(value ?? "")
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .trim()
      .toUpperCase();

    const isQuotationVoucher = (value) =>
      normalizeVoucherName(value).includes("COTIZ");

    const stateAccesInsurer = ref(false);
    const stateAccesWorkshopEquipments = ref(false);
    const stateModifiPrice = ref(false);
    const header = ref([]);
    const stateAccesCheck = ref(false);
    const isShowModalProductsOutStock = ref(false);
    const stateAccesPSerie = ref(false);

    const VALIDATEDACCES = ref([]);
    const ACCESS = [
      "ASEGURADORAS MODULO VENTAS",
      "APLICAR PRECIO 2 EN VENTAS",
      "APLICAR PRECIO 3 EN VENTAS",
      "✏ MODIFICAR PRECIO DE VENTA DEL PRODUCTO (VENTAS)",
      "VENTAS TEMPORALES MODULO VENTAS",
      "FACTURAS HOLD MODULO VENTAS",
      "AGREGAR PRODUCTOS DESDE VENTAS",
      "COTIZACIONES MODULO VENTAS",
      "APLICAR NOTA DE CREDITO MODULO VENTAS",
      "COBRAR EQUIPOS MODULO VENTAS",
      "ACTIVAR COLUMNA DE CHECK EN LA TABLA VENTAS",
      "ACTIVAR COLUMNA DE SERIE DE PRODUCTO TABLA DE VENTAS",
    ];

    //Estado de componentes
    const stateForSaleType = ref(false);
    const stateForPaymentType = ref(false);
    const stateForQuotation = ref(false);
    const spinner = ref(false);
    const stateTemporarySales = ref(false);
    const stateSalesHold = ref(false);
    const stateAppDelivery = ref(false);
    const loading = ref(false);
    const stateAddProduct = ref(false);
    const stateInsurer = ref(false);
    const salesDiscountStatus = ref(false);
    const stateQuotes = ref(false);
    const stateCreditNote = ref(false);
    const stateWorkshopEquipments = ref(false);
    const stateShowUserAccess = ref(false);
    const stateShowCombinedPayment = ref(false);
    const area = ref(""); // Para especificar el area a donde va a acceder el usuario
    const limitDiscount = ref(0); // El limite de descuento que podrá hacer el usuario
    const nameVoucher = ref(""); // Sirve para hacer alguna validaciones
    const primaryActionLabel = computed(() =>
      isQuotationVoucher(nameVoucher.value)
        ? "Registrar cotizacion"
        : "Registrar venta"
    );
    const primaryActionLoadingLabel = computed(() =>
      isQuotationVoucher(nameVoucher.value)
        ? "Registrando cotizacion"
        : "Registrando venta"
    );
    const stateInputsThePayment = ref(true); // Sirve para mostrar o ocultar el monto que pagar el cliente
    const stateShowInfoCustomer = ref(false);
    const stateForCreditToSale = ref(false); //Estado para mostrar configuracion de ventas a credito
    const arraySelectProduct = ref([]);
    const changeVoucher = ref(0);
    const customerSearchKey = ref(0);
    const idOrderQuot = ref(0);
    const selectedWorkshopOrder = ref(null);
    const workshopCustomerName = ref("");
    const prefilledCustomerData = ref(null);

    const usePriceTwo = ref(false);
    const usePriceThree = ref(false);

    //Datos de la venta en especifico
    const dataForm = ref({
      idUser: 0,
      idStore: 0,
      idTurn: 0,
      idVoucher: 0,
      idTypeOfSale: 0,
      idTypeOfPayment: 0,
      idCreditNote: null,
      total: 0,
      totalWhitDiscount: 0,
      igv: 0,
      subTotal: 0,
      otherDiscounts: 0,
      totalCreditNote: 0,
      totalCreditNoteDiference: 0,
      discount: 0,
      expireQuotation: null,
      comentary: "",
      totalPayableByInsurer: 0,
      totalPayableByCustomer: 0,
      userName: "",
      customerName: "",
      serieVoucher: "",
      numberVoucher: "",
      numberReference: "",
      currencyDescription: "",
      currencyPrefix: "",
      igvApplied: 0,
      retention: 0,
      entityBank: "",
      numberOperation: "",
      cashAmount: 0,
      targetAmount: 0,
      transferAmount: 0,
      chequeAmount: 0,
      customerAmountPaid: 0,
      customerAmountReturned: 0,
      modificationDate: null,
      sunatAnswer: 0,
      state: "",
      paymentDate: null,
      initialFee: 0,
      idCharge: null,
      nameCharge: null,
      codigo_pedido: "",
    });

    const showModalProductsOutStock = () =>
      (isShowModalProductsOutStock.value = !isShowModalProductsOutStock.value);

    const statePurchaseHistoryModal = ref(false);
    const purchaseHistorySales = ref([]);
    const purchaseHistoryLoading = ref(false);
    const purchaseHistoryError = ref(null);

    const fetchPurchaseHistory = async ({ silent = false } = {}) => {
      const customerId = infoCustomer.value.id;
      if (!customerId) return;

      const storeId = await idLocalStore();

      if (!silent) {
        purchaseHistoryLoading.value = true;
      }
      purchaseHistoryError.value = null;

      try {
        const response = await axios.get(
          `/clientes/${customerId}/historial-compras`,
          {
            params: {
              store: storeId,
              per_page: 3,
            },
          }
        );

        purchaseHistorySales.value = response?.data?.data ?? [];
      } catch (e) {
        if (!silent) {
          purchaseHistoryError.value =
            e?.response?.data?.error ||
            e?.response?.data?.message ||
            "No se pudo cargar el historial.";
        }
      } finally {
        if (!silent) {
          purchaseHistoryLoading.value = false;
        }
      }
    };

    const openPurchaseHistory = async () => {
      statePurchaseHistoryModal.value = true;
      purchaseHistoryError.value = null;
      await fetchPurchaseHistory();
    };

    const closePurchaseHistory = () => {
      statePurchaseHistoryModal.value = false;
    };

    const isWorkshopOrderProduct = (product) => Boolean(product?.isWorkshopOrder);

    const closeWorkshopEquipments = () => {
      stateWorkshopEquipments.value = false;
    };

    const syncSalesSpecificAccesses = async () => {
      const validatedAccess = await validateAccessSpecific(
        ACCESS,
        await idLocalUser()
      );

      VALIDATEDACCES.value = Array.isArray(validatedAccess) ? validatedAccess : [];

      stateAccesInsurer.value = VALIDATEDACCES.value.includes(
        "ASEGURADORAS MODULO VENTAS"
      );
      stateAccesWorkshopEquipments.value = VALIDATEDACCES.value.includes(
        "COBRAR EQUIPOS MODULO VENTAS"
      );
      stateModifiPrice.value = VALIDATEDACCES.value.includes(
        "✏ MODIFICAR PRECIO DE VENTA DEL PRODUCTO (VENTAS)"
      );
      stateAccesCheck.value = VALIDATEDACCES.value.includes(
        "ACTIVAR COLUMNA DE CHECK EN LA TABLA VENTAS"
      );
      stateAccesPSerie.value = VALIDATEDACCES.value.includes(
        "ACTIVAR COLUMNA DE SERIE DE PRODUCTO TABLA DE VENTAS"
      );
      usePriceTwo.value = VALIDATEDACCES.value.includes(
        "APLICAR PRECIO 2 EN VENTAS"
      );
      usePriceThree.value = VALIDATEDACCES.value.includes(
        "APLICAR PRECIO 3 EN VENTAS"
      );

      if (!stateAccesWorkshopEquipments.value) {
        closeWorkshopEquipments();
      }

      header.value = columsHidden(
        stateAccesInsurer.value,
        stateAccesCheck.value,
        stateAccesPSerie.value
      );
    };

    const applyWorkshopOrderSelection = async (payload) => {
      if (!payload?.customerPayload || !Array.isArray(payload?.saleLines) || !payload?.saleLines.length || !payload?.workshopOrder) {
        errorActions("No pudimos preparar la orden de taller para cargarla en la venta.");
        return;
      }

      prefilledCustomerData.value = { ...payload.customerPayload };
      getDataCustomer(payload.customerPayload);
      workshopCustomerName.value = payload.customerName || payload.customerPayload.searchInput || "";
      selectedWorkshopOrder.value = payload.workshopOrder;

      payload.saleLines.forEach((saleLine) => {
        const existingIndex = arrayOfProducts.value.findIndex(
          (product) => product.workshopOrderId === payload.workshopOrder.id &&
            (product.workshopDetailId || null) === (saleLine.workshopDetailId || null)
        );

        if (existingIndex !== -1) {
          saleLine.id = arrayOfProducts.value[existingIndex].id;
          arrayOfProducts.value.splice(existingIndex, 1, saleLine);
          return;
        }

        IDPRODUCTTEMP.value++;
        saleLine.id = IDPRODUCTTEMP.value;
        arrayOfProducts.value.push(saleLine);
      });

      closeWorkshopEquipments();
      await nextTick();
      calculateTheTotal(arrayOfProducts.value);
    };

    watch([statePurchaseHistoryModal, stateWorkshopEquipments], ([historyOpen, workshopOpen]) => {
      if (typeof document === "undefined") return;
      document.body.style.overflow = historyOpen || workshopOpen ? "hidden" : "";
    });

    onUnmounted(() => {
      if (typeof document === "undefined") return;
      document.body.style.overflow = "";
    });

    /*********************************************************************************
     * Informacion del cliente para hacer validaciones con lo datos.
     * Los datos bienen desde el componente público SearchCustomer
     *********************************************************************************
     */
    const infoCustomer = ref({
      id: 0,
      fullName: null,
      creditLimit: 0,
      maximunDiscount: 0,
      sell_with: 1,
      fixed_voucher: 0,
      paydays: null,
      document_number: 0,
      type: null,
      requiere_codigo_pedido: false,
    });

    const isConsumptionVoucher = (voucherName) =>
      normalizeVoucherName(voucherName) === "FACTURA PARA CONSUMO";

    const isValidRnc = (documentNumber) => {
      const digits = String(documentNumber || "").replace(/\D+/g, "");
      if (!/^\d{9}$/.test(digits)) {
        return false;
      }

      const weights = [7, 9, 8, 6, 5, 4, 3, 2];
      let sum = 0;
      for (let i = 0; i < 8; i += 1) {
        sum += Number(digits[i]) * weights[i];
      }

      let checkDigit = 11 - (sum % 11);
      if (checkDigit === 11) {
        checkDigit = 2;
      } else if (checkDigit === 10) {
        checkDigit = 1;
      }

      return checkDigit === Number(digits[8]);
    };

    const applyAutoVoucherByCustomer = () => {
      if (parseInt(infoCustomer.value.fixed_voucher || 0) > 0) {
        return;
      }

      if (!isConsumptionVoucher(nameVoucher.value)) {
        return;
      }

      if (!isValidRnc(infoCustomer.value.document_number)) {
        return;
      }

      typeVoucher.value = "FACTURA PARA CREDITO FISCAL";
      changeVoucher.value += 1;
    };

    const getDataCustomer = async (data) => {
      infoCustomer.value.id = data.idCustomer;
      infoCustomer.value.fullName = data.searchInput;
      dataForm.value.customerName = data.searchInput;
      infoCustomer.value.creditLimit = data.creditLimit;
      infoCustomer.value.maximunDiscount = data.maximumDiscount;
      infoCustomer.value.document_number = data.numberDocument;
      infoCustomer.value.type = data.typeCustomer;
      infoCustomer.value.sell_with = data.sell_with;
      infoCustomer.value.fixed_voucher = data.fixed_voucher;
      infoCustomer.value.paydays = data.paydays;
      infoCustomer.value.requiere_codigo_pedido = data.requiere_codigo_pedido;
      stateShowInfoCustomer.value = true;
      dataForm.value.paymentDate = data.paydays !== null ? data.paydays : null;
      changeVoucher.value++;
      applyAutoVoucherByCustomer();

    };

    /*********************************************************************************
     * Informacion de la APP DELIVERY para aplicar un porcentaje de comisiones a cada producto.
     * Lo datos bienen desde el componente público SearchAppDelivery
     *********************************************************************************
     */
    const getDataAppDelivery = async (data) => {
      if (arrayOfProducts.value.length > 0) {
        await applyCommissionForDelivery(data);
      } else {
        errorActions(
          "Lista de ventas vacía <strong>no podemos aplicar una comision de la empresa asuguradora debido a que no has agregado productos a la lista de ventas</strong>"
        );
        return;
      }
      if (arraySelectProduct.value.length <= 0) {
        errorActions(
          "Por favor selecciona <strong>los productos a los cuales se aplicará el descuento.</strong>"
        );
        return;
      }
    };

    const selectProduct = (data) => {
      const index = arraySelectProduct.value.indexOf(data.idProduct);
      if (index !== -1) {
        arraySelectProduct.value.splice(index, 1);
      } else {
        arraySelectProduct.value.push(data.idProduct);
      }
    };

    /*********************************************************************************
     * Informacion del encargado que llevara el producto
     * Lo datos bienen desde el componente público SearchUserCharge
     *********************************************************************************
     */
    const handeCharge = (data) => {
      dataForm.value.idCharge = data.id;
      dataForm.value.nameCharge = data.name;
    };
    /*********************************************************************************
     * Funcion para aplicar comision a todos los productos de la venta
     * Se aplicara la comision configurada de la empresa de delivery a cada producto
     *********************************************************************************/
    const applyCommissionForDelivery = async (data) => {
      //Recorremos todo el arreglo de producto
      const { commission } = data;
      // arrayOfProducts.value.forEach((element) => {
      //   const igvApplied = element.igvApplied;
      //   const CONFIGURE_IGV = percentage(igvApplied);
      //   const percentageOfCommission = percentage(commission);

      //   const applyCommision = element.salePrice * percentageOfCommission;

      //   element.salePrice += applyCommision;

      //   element.subTotal = parseFloat(
      //     (parseFloat(element.salePrice) / (CONFIGURE_IGV + 1)).toFixed(2)
      //   );
      //   element.igv = parseFloat(
      //     (parseFloat(element.subTotal) * CONFIGURE_IGV).toFixed(2)
      //   );
      //   element.total = parseFloat(
      //     (
      //       parseFloat(element.quantity) * parseFloat(element.salePrice)
      //     ).toFixed(2)
      //   );
      // });
      arrayOfProducts.value.forEach((element) => {
        if (arraySelectProduct.value.includes(element.idProduct)) {
          const igvApplied = element.igvApplied;
          const CONFIGURE_IGV = percentage(igvApplied);

          const applyCommision = element.salePrice * (commission / 100);
          element.salePrice += applyCommision;

          element.subTotal = parseFloat(
            (parseFloat(element.salePrice) / (CONFIGURE_IGV + 1)).toFixed(2)
          );
          element.igv = parseFloat(
            (parseFloat(element.subTotal) * CONFIGURE_IGV).toFixed(2)
          );
          element.total = parseFloat(
            (
              parseFloat(element.quantity) * parseFloat(element.salePrice)
            ).toFixed(2)
          );
        }
      });
      calculateTheTotal(arrayOfProducts.value);
    };

    /*********************************************************************************
     * Informacion la empresa aseguradora
     * Lo datos bienen desde el componente público SearchInsurer
     *********************************************************************************
     */
    const infoInsurer = ref({
      id: 0,
      bussinesName: "",
    });
    const getInsurer = async (data) => {
      if (arrayOfProducts.value.length > 0) {
        const { idInsurer, bussinesName } = data;
        infoInsurer.value.id = idInsurer;
        infoInsurer.value.bussinesName = bussinesName;
        await calculateTheTotalPaymentOfTheInsurerAndCustomer();
      } else {
        errorActions(
          "Lo sentimos no podemos aplicar el descuento por seguro a la venta, debido a que no tienes productos añadidos a la lista de ventas"
        );
      }
    };

    /*********************************************************************************
     * Informacion de la nota de credito seleccionado
     * Lo datos bienen desde el componente público SearchCreditNote
     *********************************************************************************
     */
    const infoCreditNote = ref({
      id: 0,
      amount: 0,
    });
    const getCreditNote = async (data) => {
      if (arrayOfProducts.value.length > 0) {
        const { id, amount } = data;
        dataForm.value.idCreditNote = id;

        const amountCreditNote = parseFloat(amount);

        //calculamos si la nota de credito es mayor a la venta
        if (amountCreditNote >= parseFloat(dataForm.value.totalWhitDiscount)) {
          const newAmount = amountCreditNote - dataForm.value.totalWhitDiscount;

          dataForm.value.totalCreditNote = dataForm.value.totalWhitDiscount;
          infoCreditNote.value.amount = newAmount;
          dataForm.value.totalWhitDiscount = 0;
          dataForm.value.totalCreditNoteDiference = 0;
          //Pasamos los datos que biene a los datos de nota de credito de la venta
        } else if (
          amountCreditNote < parseFloat(dataForm.value.totalWhitDiscount)
        ) {
          const newPrice = dataForm.value.totalWhitDiscount - amountCreditNote;
          dataForm.value.totalWhitDiscount = newPrice;
          dataForm.value.totalCreditNoteDiference = newPrice;
          //Pasamos los datos que biene a los datos de nota de credito de la venta
          dataForm.value.totalCreditNote = amountCreditNote;

          infoCreditNote.value.amount = 0;
        }
      } else {
        errorActions(
          "Lo sentimos no podemos aplicar la nota de crédito, debido a que no tienes productos añadidos a la lista de ventas"
        );
      }
    };

    /*********************************************************************************
     * Funcion para calcular el monto que debe de pagar la aseguradora y el monto
     * que debe de pagar el cliente segun el descuento aplicado po seguro
     *********************************************************************************
     */
    const calculateTheTotalPaymentOfTheInsurerAndCustomer = async () => {
      dataForm.value.totalPayableByCustomer = 0;
      dataForm.value.totalPayableByInsurer = 0;

      let acumulatorTotalPayableByInsurer = 0;
      arrayOfProducts.value.forEach((product) => {
        const percentageTheDiscount = percentage(product.insuranceDiscount);
        const discountForInsurer = product.total * percentageTheDiscount;
        acumulatorTotalPayableByInsurer += discountForInsurer;
      });

      dataForm.value.totalPayableByInsurer = parseFloat(
        acumulatorTotalPayableByInsurer.toFixed(2)
      );
      dataForm.value.totalPayableByCustomer = parseFloat(
        (dataForm.value.total - acumulatorTotalPayableByInsurer).toFixed(2)
      );

      dataForm.value.totalWhitDiscount = dataForm.value.totalPayableByCustomer;
      dataForm.value.cashAmount = dataForm.value.totalWhitDiscount;
    };

    /*********************************************************************************
     * Funcion para añadir productos a la lista de ventas
     * Los datos del producto biene desde el componente de SearchProduct
     *********************************************************************************/
    const arrayOfProducts = ref([]);
    const IDPRODUCTTEMP = ref(0);
    const searchedProductLocation = ref(null);

    const buildProductLineKey = (product) =>
      `${product.idProduct}|${String(product.unitMeasure || "UNIDADES").toUpperCase()}`;

    const isPromotionActiveForSeller = (promotion) => {
      if (!promotion || promotion.status === "INACTIVA") {
        return false;
      }

      const now = new Date();
      const startAt = promotion.startAt ? new Date(promotion.startAt) : null;
      const endAt = promotion.endAt ? new Date(promotion.endAt) : null;

      if (startAt && !Number.isNaN(startAt.getTime()) && startAt > now) {
        return false;
      }

      if (endAt && !Number.isNaN(endAt.getTime()) && endAt < now) {
        return false;
      }

      return true;
    };

    const describePromotionForSeller = (promotion, index) => {
      if (promotion.type === "CANTIDAD_BONIFICADA") {
        const requiredQuantity = Number(promotion.requiredQuantity || 0);
        const bonusQuantity = Number(promotion.bonusQuantity || 0);

        return `
          <div style="border:1px solid #bfdbfe;border-radius:14px;padding:16px 18px;background:#eff6ff;">
            <div style="font-size:13px;font-weight:800;color:#1d4ed8;letter-spacing:0.08em;text-transform:uppercase;">
              Promocion ${index + 1}
            </div>
            <div style="margin-top:8px;font-size:34px;line-height:1;font-weight:900;color:#1d4ed8;">
              ${requiredQuantity} X ${bonusQuantity}
            </div>
            <div style="margin-top:10px;font-size:18px;line-height:1.35;font-weight:800;color:#0f172a;">
              Compra ${requiredQuantity} y se lleva ${bonusQuantity} gratis.
            </div>
          </div>
        `;
      }

      if (promotion.type === "PRECIO_ESPECIAL") {
        const minimumQuantity = Number(promotion.requiredQuantity || 1);
        const specialPrice = Number(promotion.specialPrice || 0);
        const minimumText = minimumQuantity > 1
          ? `Compra ${minimumQuantity} o mas unidades.`
          : "Disponible desde la primera unidad.";

        return `
          <div style="border:1px solid #bfdbfe;border-radius:14px;padding:16px 18px;background:#eff6ff;">
            <div style="font-size:13px;font-weight:800;color:#1d4ed8;letter-spacing:0.08em;text-transform:uppercase;">
              Promocion ${index + 1}
            </div>
            <div style="margin-top:8px;font-size:28px;line-height:1.1;font-weight:900;color:#1d4ed8;">
              PRECIO ESPECIAL
            </div>
            <div style="margin-top:10px;font-size:20px;line-height:1.35;font-weight:800;color:#0f172a;">
              ${money()} ${format(specialPrice)}
            </div>
            <div style="margin-top:8px;font-size:17px;line-height:1.35;font-weight:800;color:#0f172a;">
              ${minimumText}
            </div>
          </div>
        `;
      }

      return `
        <div style="border:1px solid #bfdbfe;border-radius:14px;padding:16px 18px;background:#eff6ff;">
          <div style="font-size:13px;font-weight:800;color:#1d4ed8;letter-spacing:0.08em;text-transform:uppercase;">
            Promocion ${index + 1}
          </div>
          <div style="margin-top:8px;font-size:28px;line-height:1.1;font-weight:900;color:#1d4ed8;">
            PAQUETE PROMOCIONAL
          </div>
          <div style="margin-top:10px;font-size:18px;line-height:1.35;font-weight:800;color:#0f172a;">
            Este producto tiene un lote, combo o paquete promocional disponible.
          </div>
        </div>
      `;
    };

    const notifyProductPromotionsOnSelection = async (product) => {
      if (!product?.idProduct || !dataForm.value.idStore) {
        return;
      }

      const promotions = await fetchProductPromotions(
        product.idProduct,
        dataForm.value.idStore
      ).catch(() => []);

      const activePromotions = (Array.isArray(promotions) ? promotions : []).filter(
        (promotion) => isPromotionActiveForSeller(promotion)
      );

      if (activePromotions.length <= 0) {
        return;
      }

      const message = `
        <div style="text-align:left;">
          <div style="font-size:16px;line-height:1.5;font-weight:800;color:#0f172a;">
            El producto <strong>${product.productName}</strong> tiene promociones activas disponibles para esta venta.
          </div>
        </div>
        <div style="margin-top:14px;display:grid;gap:12px;">
          ${activePromotions
          .map((promotion, index) => describePromotionForSeller(promotion, index))
          .join("")}
        </div>
        <p style="margin-top:14px;font-size:15px;line-height:1.5;font-weight:800;color:#334155;">
          La promocion es una de las siguientes. Informala al cliente antes de cerrar la venta.
        </p>
      `;

      await notificationAction({
        title:
          activePromotions.length === 1
            ? "Promocion disponible"
            : "Promociones disponibles",
        msg: message,
        icon: "info",
        confirmButtonText: "OK",
      });
    };

    const recalculateOrderLine = (order, igvApplied) => {
      const totalOrder =
        Number(order.baseSalePrice ?? order.salePrice) * Number(order.quantity);

      // El descuento promocional se calcula aparte para no mezclar reglas manuales y automáticas.
      const promotionDiscountAmount = Number(order.promotionDiscountAmount || 0);
      const DISCOUNT = percentage(order.discount);
      const CONFIGURE_IGV = percentage(igvApplied);

      const totalAfterPromotion = Math.max(0, totalOrder - promotionDiscountAmount);
      const discountAmount = parseFloat((totalAfterPromotion * DISCOUNT).toFixed(2));
      const newTotal = totalAfterPromotion - discountAmount;
      const newSubTotal = newTotal / (CONFIGURE_IGV + 1);
      const newIgv = newSubTotal * CONFIGURE_IGV;

      order.subTotal = parseFloat(newSubTotal.toFixed(2));
      order.igv = parseFloat(newIgv.toFixed(2));
      order.total = parseFloat(newTotal.toFixed(2));
    };

    const syncResolvedPromotions = async () => {
      if (arrayOfProducts.value.length <= 0) {
        calculateTheTotal(arrayOfProducts.value);
        return;
      }

      const resolvedLines = await resolveSalePromotions({
        idStore: dataForm.value.idStore,
        details: arrayOfProducts.value.map((product) => ({
          idProduct: product.idProduct,
          quantity: product.quantity,
          unitMeasure: product.unitMeasure,
          quantityContained: product.quantityContained,
          salePrice: Number(product.baseSalePrice ?? product.salePrice),
        })),
      }).catch(() => null);

      const resolvedMap = new Map(
        (resolvedLines || []).map((line) => [
          `${line.idProduct}|${String(line.unitMeasure || "UNIDADES").toUpperCase()}`,
          line,
        ])
      );

      arrayOfProducts.value.forEach((product) => {
        const resolved = resolvedMap.get(buildProductLineKey(product));
        const baseSalePrice = Number(
          resolved?.baseUnitPrice ?? product.baseSalePrice ?? product.salePrice
        );

        product.baseSalePrice = baseSalePrice;
        product.promotionDiscountAmount = Number(
          resolved?.promotionDiscountAmount ?? 0
        );
        product.bonusQuantity = Number(resolved?.bonusQuantity ?? 0);
        product.appliedPromotions = Array.isArray(resolved?.appliedPromotions)
          ? resolved.appliedPromotions
          : [];
        product.salePrice = Number(
          resolved?.effectiveUnitPrice ?? product.baseSalePrice
        );
        recalculateOrderLine(product, product.igvApplied);
      });

      calculateTheTotal(arrayOfProducts.value);
    };

    const addProducts = async (data) => {
      // Muestra la ubicación del ultimo producto seleccionado en la franja de acciones.
      searchedProductLocation.value = data.location ?? null;

      let {
        discount,
        expired,
        idProduct,
        igv,
        tipo,
        igvApplied,
        insuranceDiscount,
        maximumDiscount,
        poster,
        productName,
        quantity,
        salePrice,
        subTotal,
        taxFree,
        total,
        unitMeasure,
        units,
        quantityContained,
        precio_descuento,
        vencimiento_descuento,
        productSerie,
        warranty_expiration,
        warranty_type,
        shoppingPrice,
        priceSelectedForTheCustomer,
        formBarcode,
      } = data;
      //parseamos el iva del producto
      const CONFIGURE_IGV = percentage(igvApplied);

      subTotal = parseFloat(
        (parseFloat(salePrice) / (CONFIGURE_IGV + 1)).toFixed(2)
      );
      igv = parseFloat((parseFloat(subTotal) * CONFIGURE_IGV).toFixed(2));
      total = parseFloat(
        (parseFloat(quantity) * parseFloat(salePrice)).toFixed(2)
      );

      // Buscar el producto en la lista existente
      const existingProductIndex = arrayOfProducts.value.findIndex(
        (order) =>
          order.idProduct === idProduct && order.unitMeasure === unitMeasure
      );
      let productSelectedForNotification = null;

      if (existingProductIndex !== -1) {
        // El producto ya existe en la lista, sumar la cantidad y actualizar los precios
        const existingProduct = arrayOfProducts.value[existingProductIndex];
        const newQuantity = existingProduct.quantity + quantity;

        const thereIsStock = await validateStockProduct(
          idProduct,
          newQuantity * existingProduct.quantityContained
        );

        if (thereIsStock) {
          existingProduct.quantity = newQuantity;
          existingProduct.subTotal = parseFloat(
            (subTotal * newQuantity).toFixed(2)
          );
          existingProduct.igv = parseFloat(
            (existingProduct.subTotal * CONFIGURE_IGV).toFixed(2)
          );
          existingProduct.total = parseFloat(
            (existingProduct.quantity * parseFloat(salePrice)).toFixed(2)
          );
        } else {
          errorActions(
            "Lo sentimos, no pudimos agregar el producto debido a que <strong>no cuentas con el stock suficiente</strong> <br> Actualiza el stock del producto y vuelve a intentarlo"
          );
        }
      } else {
        IDPRODUCTTEMP.value++;
        const orderData = {
          id: IDPRODUCTTEMP.value,
          discount,
          expired,
          idProduct,
          igv,
          tipo,
          igvApplied,
          insuranceDiscount,
          maximumDiscount,
          poster,
          productName,
          quantity,
          baseSalePrice: parseFloat(salePrice),
          salePrice: parseFloat(salePrice),
          subTotal,
          taxFree,
          total,
          unitMeasure,
          units,
          quantityContained,
          precio_descuento: parseFloat(precio_descuento),
          vencimiento_descuento,
          productSerie,
          warranty_expiration,
          warranty_type,
          shoppingPrice,
          showBTNPriceTwo: data.showBTNPriceTwo,
          showBTNPriceThree: data.showBTNPriceThree,
          priceSelectedForTheCustomer,
          promotionDiscountAmount: 0,
          bonusQuantity: 0,
          appliedPromotions: [],
        };
        arrayOfProducts.value.push(orderData);
        productSelectedForNotification = orderData;
      }
      await nextTick();
      if (!formBarcode) {
        const trFocus = document.querySelectorAll(".td-focus");
        if (trFocus.length > 0) {
          const tdFocus = trFocus[0].querySelectorAll("td");
          if (tdFocus.length > 2) {
            const input = tdFocus[2].querySelector("input");
            if (input) {
              await nextTick();
              input.focus();
            } else {
              console.log("No se encontró el input en el tercer <td>.");
            }
          } else {
            console.log(
              "No hay suficientes <td> en el primer tr con la clase .td-focus."
            );
          }
        } else {
          console.log("No se encontraron elementos con la clase .td-focus.");
        }
      }

      await syncResolvedPromotions();
      if (productSelectedForNotification) {
        await notifyProductPromotionsOnSelection(productSelectedForNotification);
      }
      //console.log(arrayOfProducts.value);
    };

    /*********************************************************************************
     * Funcion para eliminar un registro del arreglo de la orden
     *********************************************************************************/
    const deleteRecordFromTable = async (index) => {
      const [deletedProduct] = arrayOfProducts.value.splice(index, 1);

      if (deletedProduct?.isWorkshopOrder) {
        const stillHasWorkshopProducts = arrayOfProducts.value.some((product) =>
          isWorkshopOrderProduct(product)
        );

        if (!stillHasWorkshopProducts) {
          selectedWorkshopOrder.value = null;
        }
      }

      await syncResolvedPromotions();
    };

    /*********************************************************************************
     * Funcion para calcular el total de la orden, incluyendo el igv, subtotal y total
     *********************************************************************************/
    const calculateTheTotal = (order) => {
      //ORDERNAR EL ARRAY DE FORMA DESCENDETE
      arrayOfProducts.value.sort((a, b) => b.id - a.id);
      //Nos aseguramos que la variables se inicialicen en cero
      dataForm.value.total = 0;
      dataForm.value.subTotal = 0;
      dataForm.value.igv = 0;

      const DISCOUNT = percentage(dataForm.value.discount);

      //Recorremos todo el detalle de la orden
      order.forEach((element) => {
        let total = 0;
        let subTotal = 0;
        let igv = 0;
        //EL monto de descuento a descontar al total
        const totalDiscount = element.total * DISCOUNT;
        //parseamos el iva del producto
        const CONFIGURE_IGV = percentage(element.igvApplied);

        total = parseFloat(
          (parseFloat(element.total) - totalDiscount).toFixed(2)
        );
        subTotal = parseFloat((total / (CONFIGURE_IGV + 1)).toFixed(2));
        igv = parseFloat((parseFloat(subTotal) * CONFIGURE_IGV).toFixed(2));
        dataForm.value.total += total;
        dataForm.value.subTotal += subTotal;
        dataForm.value.igv += igv;
      });

      calculateAmountPaymentCustomer();
      // console.log(arrayOfProducts.value);
    };

    /*********************************************************************************
     * Funcion para validar cuanto va a pagar el cliente
     *********************************************************************************/

    const calculateAmountPaymentCustomer = () => {
      dataForm.value.totalWhitDiscount = dataForm.value.total; //Total que debe de pagar el cliente
      if (dataForm.value.otherDiscounts > 0) {
        dataForm.value.totalWhitDiscount =
          dataForm.value.total - dataForm.value.otherDiscounts;
      }

      dataForm.value.cashAmount = dataForm.value.totalWhitDiscount;
      if (dataForm.value.totalCreditNote > 0) {
        dataForm.value.totalWhitDiscount =
          dataForm.value.totalCreditNoteDiference -
          dataForm.value.otherDiscounts;
      }
      dataForm.value.cashAmount = dataForm.value.totalWhitDiscount;
    };
    /*********************************************************************************
     * Funcion para cambiar la cantidad de la orden
     *********************************************************************************/
    const handleQuantityChange = async (index, event) => {
      if (isWorkshopOrderProduct(arrayOfProducts.value[index])) {
        event.target.value = arrayOfProducts.value[index].quantity;
        return;
      }

      const newQuantity =
        parseFloat(event.target.value) !== ""
          ? parseFloat(event.target.value)
          : 1.0;
      if (isNaN(newQuantity) || newQuantity <= 0) {
        errorActions("La cantidad a vender debe de ser mayor o igual a 1");
        event.target.value = arrayOfProducts.value[index].quantity;
        return;
      }
      const quantityForValidate =
        newQuantity * arrayOfProducts.value[index].quantityContained;

      const tipo = arrayOfProducts.value[index].tipo;
      if (!isQuotationVoucher(nameVoucher.value) && tipo !== 0) {
        const thereIsStock = await validateStockProduct(
          arrayOfProducts.value[index].idProduct,
          quantityForValidate
        );
        if (thereIsStock) {
          arrayOfProducts.value[index].quantity = newQuantity;
          await syncResolvedPromotions();
        } else {
          errorActions(
            "Lo sentimos, no pudimo agregar el producto debido a que <strong>no cuentas con el stock suficiente</strong> <br> Actualiza el stock del producto y vuelve a intentarlo"
          );
          event.target.value = arrayOfProducts.value[index].quantity;
          return;
        }
      } else {
        arrayOfProducts.value[index].quantity = newQuantity;
        await syncResolvedPromotions();
      }
    };

    /*********************************************************************************
     * Funcion para cambiar la cantidad de la orden
     *********************************************************************************/
    const handlePriceForDiscount = async (index, event, igvApplied) => {
      let newPrice = 0;
      if (event.target.checked) {
        newPrice = parseFloat(arrayOfProducts.value[index].precio_descuento);
        arrayOfProducts.value[index].precio_descuento = parseFloat(
          arrayOfProducts.value[index].salePrice
        );
      } else {
        arrayOfProducts.value[index].salePrice = parseFloat(
          arrayOfProducts.value[index].precio_descuento
        );
        newPrice = parseFloat(arrayOfProducts.value[index].salePrice);
      }

      arrayOfProducts.value[index].salePrice = newPrice;

      updateDetailData(index, igvApplied);
    };
    /*********************************************************************************
     * Funcion para cambiar la cantidad de la orden
     *********************************************************************************/
    const handleProductSerie = async (index, event) => {
      arrayOfProducts.value[index].productSerie = event.target.value;
    };
    /*********************************************************************************
     * Funcion para actualizar la orden
     *********************************************************************************/
    const updateDetailData = (index, igvApplied) => {
      const order = arrayOfProducts.value[index];

      recalculateOrderLine(order, igvApplied);

      calculateTheTotal(arrayOfProducts.value);
    };

    /*********************************************************************************
     * Funcion para aplicar el descuento por seguro a cada producto
     *********************************************************************************/
    const handleInsuranceDiscountChange = (index, event) => {
      const newInsuranceDiscount =
        parseFloat(event.target.value) !== ""
          ? parseFloat(event.target.value)
          : 1.0;
      arrayOfProducts.value[index].insuranceDiscount = newInsuranceDiscount;
    };

    /*********************************************************************************
     * Funcion para aplicar el descuento al producto producto
     *********************************************************************************/
    const handleDiscountChange = (index, event, igvApplied) => {
      const newDiscount =
        parseFloat(event.target.value) !== ""
          ? parseFloat(event.target.value)
          : 1.0;
      if (newDiscount > arrayOfProducts.value[index].maximumDiscount) {
        errorActions(
          `El descuento que usted puede aplicar a este producto debe de ser menor o igual al <strong>${arrayOfProducts.value[index].maximumDiscount}%</strong>`
        );
        event.target.value = 0;
        return;
      }
      arrayOfProducts.value[index].discount = newDiscount;
      updateDetailData(index, igvApplied);
    };
    /*********************************************************************************
     * Funcion para modificar el precio de venta del producto
     *********************************************************************************/
    const handleUnitPriceChange = async (
      index,
      event,
      igvApplied,
      shoppingPrice,
      salePrice
    ) => {
      if (isWorkshopOrderProduct(arrayOfProducts.value[index])) {
        event.target.value = arrayOfProducts.value[index].salePrice;
        return;
      }

      const newPrice =
        parseFloat(event.target.value) !== ""
          ? parseFloat(event.target.value)
          : 1.0;
      if (newPrice <= parseFloat(shoppingPrice)) {
        errorActions(
          `Lo sentimos, no podemos modificar el precio de venta  <strong>debido que que es igual o menor al precio de compra</strong>`
        );
        event.target.value = salePrice;
        return;
      }
      arrayOfProducts.value[index].baseSalePrice = newPrice;
      arrayOfProducts.value[index].salePrice = newPrice;
      await syncResolvedPromotions();
      //console.log(arrayOfProducts.value)
    };

    /*********************************************************************************
     * Funcion para aplicar el descuento al producto producto
     *********************************************************************************/
    const handleUnitMeasureChange = async (index, event) => {
      if (isWorkshopOrderProduct(arrayOfProducts.value[index])) {
        event.target.value = `${arrayOfProducts.value[index].salePrice}|${arrayOfProducts.value[index].quantityContained}|${arrayOfProducts.value[index].unitMeasure}`;
        return;
      }

      const [price, quantityContained, unitMeasure] =
        event.target.value.split("|");
      //Calculamos la cantidad de productos
      const quantity =
        arrayOfProducts.value[index].quantity * parseFloat(quantityContained);

      //OBTENCION DE LAS UNIDADES DE MEDIDA
      const selectUM = arrayOfProducts.value[index].units.filter(
        (item) => item.unidad_de_medida === unitMeasure
      );

      if (!isQuotationVoucher(nameVoucher.value)) {
        //Validamos que el producto cuente con stock suficiente para ser cambiado de unidad de medida
        const thereIsStock = await validateStockProduct(
          arrayOfProducts.value[index].idProduct,
          quantity
        );

        if (thereIsStock) {
          arrayOfProducts.value[index].baseSalePrice = Number(price);
          arrayOfProducts.value[index].salePrice = Number(price);
          arrayOfProducts.value[index].unitMeasure = unitMeasure;
          arrayOfProducts.value[index].quantityContained =
            parseFloat(quantityContained);

          if (selectUM[0].precio_dos > 0) {
            arrayOfProducts.value[index].showBTNPriceTwo = true;
          } else {
            arrayOfProducts.value[index].showBTNPriceTwo = false;
          }
          if (selectUM[0].precio_tres > 0) {
            arrayOfProducts.value[index].showBTNPriceThree = true;
          } else {
            arrayOfProducts.value[index].showBTNPriceThree = false;
          }
          await syncResolvedPromotions();
        } else {
          errorActions(
            "Lo sentimos, no pudimo agregar el producto debido a que <strong>no cuentas con el stock suficiente</strong> <br> Actualiza el stock del producto y vuelve a intentarlo"
          );
          event.target.selectedIndex = 0;
          return;
        }
      } else {
        arrayOfProducts.value[index].baseSalePrice = Number(price);
        arrayOfProducts.value[index].salePrice = Number(price);
        arrayOfProducts.value[index].unitMeasure = unitMeasure;
        arrayOfProducts.value[index].quantityContained =
          parseFloat(quantityContained);

        if (selectUM[0].precio_dos > 0) {
          arrayOfProducts.value[index].showBTNPriceTwo = true;
        } else {
          arrayOfProducts.value[index].showBTNPriceTwo = false;
        }
        if (selectUM[0].precio_tres > 0) {
          arrayOfProducts.value[index].showBTNPriceThree = true;
        } else {
          arrayOfProducts.value[index].showBTNPriceThree = false;
        }
        await syncResolvedPromotions();
      }
      arrayOfProducts.value[index].priceSelectedForTheCustomer = 1;
    };

    /*********************************************************************************
     * Funcion para cambiar el precio del producto por PRECIO 1, PRECIO 2, PRECIO 3
     *********************************************************************************/
    const handlePrices = async (index, event, product) => {
      if (isWorkshopOrderProduct(arrayOfProducts.value[index])) {
        event.target.value = 1;
        return;
      }

      const price = parseInt(event.target.value);
      const unitMeasure = arrayOfProducts.value[index].unitMeasure;
      const selectUM = product.units.filter(
        (item) => item.unidad_de_medida === unitMeasure
      );
      if (selectUM && selectUM.length > 0) {
        if (price === 1) {
          arrayOfProducts.value[index].baseSalePrice = selectUM[0].precio;
        } else if (price === 2) {
          if (parseFloat(selectUM[0].precio_dos) > 0) {
            arrayOfProducts.value[index].baseSalePrice = selectUM[0].precio_dos;
          }
        } else if (price === 3) {
          if (parseFloat(selectUM[0].precio_dos) > 0) {
            arrayOfProducts.value[index].baseSalePrice = selectUM[0].precio_tres;
          }
        }
        arrayOfProducts.value[index].salePrice = Number(
          arrayOfProducts.value[index].baseSalePrice
        );
        arrayOfProducts.value[index].priceSelectedForTheCustomer = price;
        await syncResolvedPromotions();
      }
    };

    /*********************************************************************************
     * Funcion para validar el stock del producto
     *********************************************************************************/
    const validateStockProduct = async (id, stock) => {
      try {
        const response = await axios.get(
          `productos-para-venta/${id}?stock=${stock}`,
          {
            methods: {
              "Content-Type": "application/json",
            },
          }
        );
        const data = await response.data;
        if (data === true) return true;
        return false;
      } catch (error) {
        errorActions(error);
        return false;
      }
    };

    /*********************************************************************************
     * Funcion aplicar descuento a la venta
     *********************************************************************************/
    const applyDiscountToSale = async () => {
      const amountDiscount =
        dataForm.value.discount === null || dataForm.value.discount === ""
          ? 0
          : dataForm.value.discount;

      dataForm.value.discount = amountDiscount;
      /*
      calculateTheTotal(arrayOfProducts.value);

      const discount = percentage(limitDiscount.value);
      const discountCustomer = percentage(infoCustomer.value.maximunDiscount);
      let discountTheform = percentage(amountDiscount);
      if (discountTheform > discountCustomer) {
        errorActions(
          `El descuento máximo que puedes aplicar al cliente <strong>${infoCustomer.value.fullName}</strong> debe de ser: <br> <strong> menor o igual al ${infoCustomer.value.maximunDiscount}%</strong>`
        );
        dataForm.value.discount = 0;
        discountTheform = 0;
      }

      if (discountTheform > discount) {
        errorActions(
          `Lo sentimos usted tiene permitido reazalir un descuento <br> <strong> menor o igual al ${limitDiscount.value}%</strong>`
        );
        dataForm.value.discount = 0;
        discountTheform = 0;
      }
        */
      // const amountForDiscount = dataForm.value.total * discountTheform;
      // dataForm.value.total = dataForm.value.total - amountForDiscount;

      // dataForm.value.subTotal = parseFloat(
      //   (parseFloat(dataForm.value.total) / TO_DIVIDE).toFixed(2)
      // );
      // dataForm.value.igv = parseFloat(
      //   (parseFloat(dataForm.value.subTotal) * TO_MULTIPLY).toFixed(2)
      // );

      calculateTheTotal(arrayOfProducts.value);
    };

    const resetPaymentAmounts = () => {
      dataForm.value.cashAmount = 0;
      dataForm.value.targetAmount = 0;
      dataForm.value.transferAmount = 0;
      dataForm.value.chequeAmount = 0;
    };

    const normalizeCreditInitialPaymentAmounts = () => {
      resetPaymentAmounts();

      const initialFee = parseFloat(dataForm.value.initialFee || 0);
      if (initialFee <= 0) {
        return;
      }

      if (dataForm.value.idTypeOfPayment === 1) {
        dataForm.value.cashAmount = initialFee;
      } else if (dataForm.value.idTypeOfPayment === 2) {
        dataForm.value.targetAmount = initialFee;
      } else if (dataForm.value.idTypeOfPayment === 3) {
        dataForm.value.transferAmount = initialFee;
      } else if (dataForm.value.idTypeOfPayment === 4) {
        dataForm.value.chequeAmount = initialFee;
      }
    };

    //recepcion de datos desde el componente publico
    const getSelectTypeOfPayment = (data) => {
      dataForm.value.idTypeOfPayment = data;
      if (data === 1 || data === 5) {
        stateForPaymentType.value = false;
      } else {
        stateForPaymentType.value = true;
      }
      if (data === 5) {
        resetPaymentAmounts();
        showCombinedPayments();
      }
      if (data !== 1) {
        activeInputForPaymentCustomer(false);
      } else {
        activeInputForPaymentCustomer(true);
        dataForm.value.cashAmount = dataForm.value.totalWhitDiscount;
      }

      if (dataForm.value.idTypeOfSale !== 1) {
        normalizeCreditInitialPaymentAmounts();
      }
    };
    const getSelectTypeOfSale = (data) => {
      dataForm.value.idTypeOfSale = data;
      if (data == 1) {
        stateForSaleType.value = false;
        enableAndDisabledSelects(false);
        activeInputForPaymentCustomer(true);
        stateForCreditToSale.value = false;
        calculateAmountPaymentCustomer();
        dataForm.value.paymentDate = null;
      } else {
        stateForSaleType.value = true;
        resetPaymentAmounts();
        enableAndDisabledSelects(true);
        activeInputForPaymentCustomer(false);
        stateForCreditToSale.value = true;
        dataForm.value.paymentDate = infoCustomer.value.paydays;
      }
    };

    const activeInputForPaymentCustomer = (state) => {
      stateInputsThePayment.value = state;
      dataForm.value.customerAmountPaid = 0;
      dataForm.value.customerAmountReturned = 0;
    };
    const enableAndDisabledSelects = (state) => {
      const paymentTypeSelect = document.getElementById("idTypeOfPayment");
      if (paymentTypeSelect) {
        paymentTypeSelect.disabled = state;
      }
      dataForm.value.paymentDate = null;
      dataForm.value.initialFee = 0;
      if (state) {
        resetPaymentAmounts();
      }
    };
    const typeVoucher = ref(null);
    const getSelectVouchersOfSale = async (data) => {
      dataForm.value.idVoucher = data.id;
      nameVoucher.value = data.name;
      if (parseInt(infoCustomer.value.fixed_voucher) <= 0) {
        typeVoucher.value = null;
      }
      if (isQuotationVoucher(data.name)) {
        stateForQuotation.value = true;
        stateInputsThePayment.value = false;
      } else if (
        data.name.trim() === "PEDIDO" ||
        data.name.trim() === "PEDIDO CLIENTE" ||
        data.name.trim() === "FACTURA HOLD" ||
        data.name.trim() === "FACTURAS HOLD" ||
        data.name.trim() === "FACTURA OLD" ||
        data.name.trim() === "FACTURAS OLD"
      ) {
        stateInputsThePayment.value = false;
        stateForQuotation.value = false;
      } else {
        stateForQuotation.value = false;
        dataForm.value.expireQuotation = null;
        stateInputsThePayment.value = true;
      }
      if (parseInt(infoCustomer.value.fixed_voucher) > 0) {
        await nextTick();
        nameVoucher.value = data.name;
      }

      if (
        nameVoucher.value !== "PEDIDO CLIENTE" &&
        !isQuotationVoucher(nameVoucher.value)
      ) {
        activeInputForPaymentCustomer(true);
      } else {
        activeInputForPaymentCustomer(false);
      }
    };

    const showTemporarySales = async () => {
      if (VALIDATEDACCES.value.includes("VENTAS TEMPORALES MODULO VENTAS")) {
        stateTemporarySales.value = !stateTemporarySales.value;
        stateSalesHold.value = false;
        stateAppDelivery.value = false;
        stateInsurer.value = false;
        stateQuotes.value = false;
        stateCreditNote.value = false;
      } else {
        errorActions(
          "Lo sentimos no podemos aperturar esta funcionalidad debido a que <strong>no tienes el acceso permitido a este modulo</strong>"
        );
      }
    };
    const showSalesHold = async () => {
      if (VALIDATEDACCES.value.includes("FACTURAS HOLD MODULO VENTAS")) {
        stateSalesHold.value = !stateSalesHold.value;
        if (stateSalesHold.value) {
          typeVoucher.value = "FACTURA PARA CONSUMO";
        } else {
          typeVoucher.value = null;
        }
        stateTemporarySales.value = false;
        stateAppDelivery.value = false;
        stateInsurer.value = false;
        stateQuotes.value = false;
        stateCreditNote.value = false;
      } else {
        errorActions(
          "Lo sentimos no podemos aperturar esta funcionalidad debido a que <strong>no tienes el acceso permitido a este modulo</strong>"
        );
      }
      changeVoucher.value++;
    };
    const showAppDelivery = () => {
      stateAppDelivery.value = !stateAppDelivery.value;
      stateSalesHold.value = false;
      stateTemporarySales.value = false;
      stateInsurer.value = false;
      stateQuotes.value = false;
      stateCreditNote.value = false;
      stateWorkshopEquipments.value = false;
    };
    const showInsurer = () => {
      stateInsurer.value = !stateInsurer.value;
      stateSalesHold.value = false;
      stateTemporarySales.value = false;
      stateAppDelivery.value = false;
      stateQuotes.value = false;
      stateCreditNote.value = false;
      stateWorkshopEquipments.value = false;
    };
    const showWorkshopEquipments = async () => {
      await syncSalesSpecificAccesses();

      if (!VALIDATEDACCES.value.includes("COBRAR EQUIPOS MODULO VENTAS")) {
        errorActions(
          "Lo sentimos no podemos aperturar esta funcionalidad debido a que <strong>no tienes el acceso permitido a este modulo</strong>"
        );
        return;
      }

      if (!stateWorkshopEquipments.value) {
        const activeElement = document.activeElement;
        if (activeElement && typeof activeElement.blur === "function") {
          activeElement.blur();
        }
      }

      stateWorkshopEquipments.value = !stateWorkshopEquipments.value;
      stateSalesHold.value = false;
      stateTemporarySales.value = false;
      stateAppDelivery.value = false;
      stateInsurer.value = false;
      stateQuotes.value = false;
      stateCreditNote.value = false;
    };
    const showAddProduct = async () => {
      if (VALIDATEDACCES.value.includes("AGREGAR PRODUCTOS DESDE VENTAS")) {
        stateAddProduct.value = !stateAddProduct.value;
      } else {
        errorActions(
          "Lo sentimos no podemos aperturar esta funcionalidad debido a que <strong>no tienes el acceso permitido a este modulo</strong>"
        );
      }
    };
    const showQuotes = async () => {
      if (VALIDATEDACCES.value.includes("COTIZACIONES MODULO VENTAS")) {
        stateQuotes.value = !stateQuotes.value;
        stateSalesHold.value = false;
        stateTemporarySales.value = false;
        stateAppDelivery.value = false;
        stateInsurer.value = false;
        stateCreditNote.value = false;
        stateWorkshopEquipments.value = false;
      } else {
        errorActions(
          "Lo sentimos no podemos aperturar esta funcionalidad debido a que <strong>no tienes el acceso permitido a este modulo</strong>"
        );
      }
    };
    const showCreditNote = async () => {
      if (
        VALIDATEDACCES.value.includes("APLICAR NOTA DE CREDITO MODULO VENTAS")
      ) {
        stateCreditNote.value = !stateCreditNote.value;
        stateSalesHold.value = false;
        stateTemporarySales.value = false;
        stateAppDelivery.value = false;
        stateInsurer.value = false;
        stateQuotes.value = false;
        stateWorkshopEquipments.value = false;
      } else {
        errorActions(
          "Lo sentimos no podemos aperturar esta funcionalidad debido a que <strong>no tienes el acceso permitido a este modulo</strong>"
        );
      }
    };
    const getAmountAgreed = (data) => {
      dataForm.value.otherDiscounts += parseFloat(data);
    };
    const showValidateUserAccess = (areas) => {
      stateShowUserAccess.value = !stateShowUserAccess.value;
      area.value = areas;
      const discountInput = document.getElementById("discountSale");
      if (discountInput) {
        discountInput.setAttribute("readonly", true);
      }
    };
    const showCombinedPayments = () => {
      stateShowCombinedPayment.value = !stateShowCombinedPayment.value;
    };

    /*********************************************************************************
     * Funcion para validar si el usuario tiene acceso al modulo especifico del sistema
     *********************************************************************************/
    const validateAccess = async (data) => {
      salesDiscountStatus.value = data.state;
      limitDiscount.value = data.discount;
    };

    const counterKeyTypeOfSale = ref(0);
    const counterKeyTypeOfPayment = ref(0);
    const cancelSale = async () => {
      const customerInput = document.getElementById("inputCustomer");
      if (customerInput) {
        customerInput.value = "";
      }
      arrayOfProducts.value = [];
      stateForSaleType.value = false;
      stateForPaymentType.value = false;
      spinner.value = false;
      stateTemporarySales.value = false;
      stateSalesHold.value = false;
      stateAppDelivery.value = false;
      loading.value = false;
      stateAddProduct.value = false;
      stateInsurer.value = false;
      salesDiscountStatus.value = false;
      stateShowUserAccess.value = false;
      stateShowCombinedPayment.value = false;
      showQuotes.value = false;
      area.value = "";
      limitDiscount.value = 0;
      stateInputsThePayment.value = true;
      if (isQuotationVoucher(nameVoucher.value)) {
        stateForQuotation.value = true;
        stateInputsThePayment.value = false;
      }
      if (
        nameVoucher.value.trim() === "PEDIDO" ||
        nameVoucher.value.trim() === "PEDIDO CLIENTE" ||
        nameVoucher.value.trim() === "FACTURA HOLD" ||
        nameVoucher.value.trim() === "FACTURAS HOLD" ||
        nameVoucher.value.trim() === "FACTURA OLD" ||
        nameVoucher.value.trim() === "FACTURAS OLD"
      ) {
        stateInputsThePayment.value = false;
        stateForQuotation.value = false;
      }

      if (dataForm.value.idTypeOfSale !== 1) {
        stateForQuotation.value = true;
        stateInputsThePayment.value = false;
      }

      dataForm.value.idCreditNote = null;
      dataForm.value.codigo_pedido = "";
      dataForm.value.total = 0;
      dataForm.value.totalWhitDiscount = 0;
      dataForm.value.igv = 0;
      dataForm.value.subTotal = 0;
      dataForm.value.otherDiscounts = 0;
      dataForm.value.totalCreditNote = 0;
      dataForm.value.totalCreditNoteDiference = 0;
      dataForm.value.discount = 0;
      dataForm.value.expireQuotation = null;
      dataForm.value.comentary = "";
      dataForm.value.totalPayableByInsurer = 0;
      dataForm.value.totalPayableByCustomer = 0;
      dataForm.value.customerName = "";
      dataForm.value.serieVoucher = "";
      dataForm.value.numberVoucher = "";
      dataForm.value.numberReference = "";
      dataForm.value.retention = 0;
      dataForm.value.entityBank = "";
      dataForm.value.numberOperation = "";
      dataForm.value.cashAmount = 0;
      dataForm.value.targetAmount = 0;
      dataForm.value.transferAmount = 0;
      dataForm.value.chequeAmount = 0;
      dataForm.value.customerAmountPaid = 0;
      dataForm.value.customerAmountReturned = 0;
      dataForm.value.modificationDate = null;
      dataForm.value.sunatAnswer = 0;
      dataForm.value.state = "";
      dataForm.value.paymentDate = null;
      dataForm.value.initialFee = 0;
      dataForm.value.idCharge = null;
      dataForm.value.nameCharge = null;
      infoCustomer.value.id = 0;
      infoCustomer.value.sell_with = 1;
      infoCustomer.value.fixed_voucher = 0;
      infoCustomer.value.paydays = null;
      infoCustomer.value.document_number = 0;
      infoCustomer.value.requiere_codigo_pedido = false;
      selectedWorkshopOrder.value = null;
      workshopCustomerName.value = "";
      prefilledCustomerData.value = null;
      IDPRODUCTTEMP.value = 0;
      infoInsurer.value.id = 0;
      stateShowInfoCustomer.value = false;
      infoOrders.value.id = 0;
      infoCreditNote.value.id = 0;
      infoCreditNote.value.amount = 0;
      stateCreditNote.value = false;
      idOrderQuot.value = 0;

      dataForm.value.userName = await localUserName();

      counterKeyTypeOfPayment.value++;
      counterKeyTypeOfSale.value++;
      changeVoucher.value++;
      customerSearchKey.value++;

      arraySelectProduct.value = [];
    };

    /*********************************************************************************
     * Funcion obtener el valor de lo multiples pagos
     *********************************************************************************/
    const getCombinedPayment = (data) => {
      const { cashAmount, targetAmount, transferAmount, chequeAmount } = data;
      dataForm.value.cashAmount = cashAmount;
      dataForm.value.targetAmount = targetAmount;
      dataForm.value.transferAmount = transferAmount;
      dataForm.value.chequeAmount = chequeAmount;
    };

    /*********************************************************************************
     * Funcion para calcular el vuelto del cliente si el tiepo de pago el efectivo
     *********************************************************************************/
    const calculteCustomerAmountReturned = () => {
      dataForm.value.customerAmountReturned = (
        dataForm.value.customerAmountPaid - dataForm.value.totalWhitDiscount
      ).toFixed(2);
    };

    /*********************************************************************************
     * Funcion para traer el nombre del cliente
     *********************************************************************************/
    const getFullNameCustomer = async () => {
      const customerInput = document.getElementById("inputCustomer");
      const customerNameFromInput = customerInput?.value?.trim() || "";

      dataForm.value.customerName =
        customerNameFromInput ||
        infoCustomer.value.fullName ||
        workshopCustomerName.value ||
        "";
    };

    /*********************************************************************************
     * Funcion traer los datos de un pedido, cotizacion o venta temporal
     *********************************************************************************/
    const infoOrders = ref({
      id: 0,
    });
    const getOrder = async (data) => {
      idOrderQuot.value = data?.id ?? 0;
      infoCustomer.value.id = data.idCustomer;
      infoCustomer.value.fullName = data.nameCustomer;
      dataForm.value.customerName = data.nameCustomer;
      dataForm.value.comentary = data.comentary;
      dataForm.value.userName = data.userName;
      infoOrders.value.id = data.id;
      const customerInput = document.getElementById("inputCustomer");
      if (customerInput) {
        customerInput.value = data.nameCustomer;
      }

      if (
        nameVoucher.value === "REGIMENES ESPECIAL" ||
        nameVoucher.value === "REGIMENES ESPECIALES" ||
        nameVoucher.value === "FACTURA" ||
        nameVoucher.value === "REGÍMENES ESPECIALES" ||
        nameVoucher.value === "REGIMEN ESPECIAL"
      ) {
        arrayOfProducts.value = data.detailOrder.map((item) => ({
          ...item,
          baseSalePrice: item.baseSalePrice ?? item.salePrice ?? item.precio_de_venta,
          promotionDiscountAmount: item.promotionDiscountAmount ?? 0,
          bonusQuantity: item.bonusQuantity ?? 0,
          appliedPromotions: item.appliedPromotions ?? [],
          igv: 0,
          igvApplied: 0,
          id: IDPRODUCTTEMP.value++,
        }));
      } else {
        arrayOfProducts.value = data.detailOrder.map((item) => ({
          ...item,
          baseSalePrice: item.baseSalePrice ?? item.salePrice ?? item.precio_de_venta,
          promotionDiscountAmount: item.promotionDiscountAmount ?? 0,
          bonusQuantity: item.bonusQuantity ?? 0,
          appliedPromotions: item.appliedPromotions ?? [],
          id: IDPRODUCTTEMP.value++,
        }));
        arrayOfProducts.value.sort((a, b) => b.id - a.id);
      }

      if ("idVoucher" in data) {
        infoCustomer.value.fixed_voucher = data.idVoucher;
        changeVoucher.value++;
      }

      calculateTheTotal(arrayOfProducts.value);

      if (parseInt(data.customer.id) > 1) {
        infoCustomer.value.maximunDiscount =
          data.customer.descuento_limite_asignado;
        infoCustomer.value.creditLimit = parseFloat(
          data.customer.limite_de_credito
        );
        infoCustomer.value.type = data.customer.tipo_de_customer;
        infoCustomer.value.document_number = data.customer.numero_documento;
        if (parseInt(data.customer.paydays) > 0) {
          infoCustomer.value.paydays = calculatePaymentDate(
            data.customer.paydays
          );
          dataForm.value.paymentDate = infoCustomer.value.paydays;
        }
      }
    };

    /*********************************************************************************
     * Funcion para validar si un producto tiene un descuento por seguro
     *********************************************************************************/
    const validateStateForInsurer = async () => {
      arrayOfProducts.value.forEach((data) => {
        if (data.insuranceDiscount > 0) {
          return true;
        }
      });
      return false;
    };

    /*********************************************************************************
     * Validamos los tipos de pagos y asignamos sus respectivos monto siempre en
     * cuando sea EFECTIVO, CHEQUE, TRANSFERENCIA O TARJETA
     *********************************************************************************/
    const assignAmountToPaymentType = async () => {
      if (dataForm.value.idTypeOfSale !== 1) {
        normalizeCreditInitialPaymentAmounts();
        return;
      }

      if (
        dataForm.value.idTypeOfPayment === 1 ||
        dataForm.value.idTypeOfPayment === 2 ||
        dataForm.value.idTypeOfPayment === 3 ||
        dataForm.value.idTypeOfPayment === 4
      ) {
        resetPaymentAmounts();
        if (dataForm.value.idTypeOfPayment === 1) {
          dataForm.value.cashAmount = dataForm.value.totalWhitDiscount;
        } else if (dataForm.value.idTypeOfPayment === 2) {
          dataForm.value.targetAmount = dataForm.value.totalWhitDiscount;
        } else if (dataForm.value.idTypeOfPayment === 3) {
          dataForm.value.transferAmount = dataForm.value.totalWhitDiscount;
        } else if (dataForm.value.idTypeOfPayment === 4) {
          dataForm.value.chequeAmount = dataForm.value.totalWhitDiscount;
        }
      }
    };

    /*********************************************************************************
     * Funcion para traer la deuda total del cliente
     *********************************************************************************/
    const checkTotalCustomerCredit = async () => {
      if (infoCustomer.value.id === 0 || infoCustomer.value.id === null) {
        errorActions(
          "Lo sentimos no podemos realizar la emisión de venta a crédito debido a que no tienes seleccionado un cliente"
        );
        spinner.value = false;
        return false;
      }
      const response = await axios
        .get("verificar-credito/" + infoCustomer.value.id)
        .catch((error) => {
          errorActions(error);
          return null;
        });

      if (!response) {
        spinner.value = false;
        return false;
      }

      const data = Number(response?.data?.total ?? 0);
      const totalSale =
        parseFloat(data) +
        (dataForm.value.totalWhitDiscount - dataForm.value.initialFee);

      if (totalSale > infoCustomer.value.creditLimit) {
        errorActions(
          `Lo tentimos no podemos realizar la emision de la venta a credito.
          <br> <strong>El cliente ya supera el limite de credito asignado</strong>
          <br>------------------------------- <br>
          DEUDA ANTERIOR: <strong class="text-red-500">${money() + data
          }</strong>
          <br>-------------------------------<br> DEUDA ANTERIOR + VENTA ACTUAL <br>
          <strong class="text-blue-500">${money() + totalSale.toFixed(2)
          }</strong>
          <br>-------------------------------<br> LIMITE DE CREDITO DEL CLIENTE <br>
          <strong class="text-green-500">${money() + infoCustomer.value.creditLimit
          }</strong>`
        );
        spinner.value = false;
        return false;
      }
      return true;
    };

    /*********************************************************************************
     * Funcion para validar el estado de la caja
     *********************************************************************************/
    const validateBoxe = async () => {
      const [idStore, idUser, idTurn] = await Promise.all([
        idLocalStore(),
        idLocalUser(),
        idLocalTurn(),
      ]);

      const response = await axios
        .get(
          `caja/check-status/?idstore=${idStore}&iduser=${idUser}&idturn=${idTurn}`
        )
        .catch(() => null);

      if (!response?.data) {
        return false;
      }

      const isOpen = response.data.msg === "caja abierta";
      localStorage.setItem("boxState", String(isOpen));

      return isOpen;
    };

    /*********************************************************************************
     * Funcion para insertar la venta
     *********************************************************************************/
    const productsOutOfStock = ref([]);
    const typePrintVoucher = ref("");
    const insert = async () => {
      if (
        infoCustomer.value.requiere_codigo_pedido &&
        (!dataForm.value.codigo_pedido ||
          dataForm.value.codigo_pedido.trim().length <= 2)
      ) {
        errorActions("Por favor ingresa el código de pedido de delivery");
        return;
      }

      if (
        nameVoucher.value === "FACTURA PARA CONSUMO" &&
        infoCustomer.value.id === 1 &&
        dataForm.value.total >= 250000
      ) {
        errorActions("Para montos mayores a 250 000, debe de ser un cliente con RNC valido");
        return;
      }
      if (
        nameVoucher.value === "FACTURA PARA CREDITO FISCAL" &&
        (infoCustomer.value.id === 1 || !infoCustomer.value?.id || parseInt(infoCustomer.value.document_number) <= 0)
      ) {
        errorActions("Debes de seleccionar un <strong>cliente para emitir este tipo de comprobante</strong>.");
        return;
      }

      spinner.value = true;
      productsOutOfStock.value = [];
      if (!isQuotationVoucher(nameVoucher.value)) {
        const productsForStockValidation = arrayOfProducts.value.filter(
          (product) => !isWorkshopOrderProduct(product)
        );
        const existStock = await VerifyStocks(productsForStockValidation);
        if (productsForStockValidation.length > 0 && !existStock.state) {
          const { message, details } = existStock;
          productsOutOfStock.value = details;
          errorActions(message);
          spinner.value = false;
          return;
        }
      }

      if (
        nameVoucher.value.trim() === "FACTURA ELECTRONICA" ||
        nameVoucher.value.trim() === "FACTURA ELECTRÓNICA" ||
        nameVoucher.value.trim() === "NOTA DE VENTA" ||
        nameVoucher.value.trim() === "BOLETA ELECTRÓNICA" ||
        nameVoucher.value.trim() === "BOLETA ELECTRONICA" ||
        nameVoucher.value.trim() === "BOLETA" ||
        nameVoucher.value.trim() === "FACTURA" ||
        nameVoucher.value.trim() === "FACTURA PARA CREDITO FISCAL" ||
        nameVoucher.value.trim() === "FACTURA PARA CONSUMO" ||
        nameVoucher.value.trim() === "COMPROBANTE GUBERNAMENTAL" ||
        nameVoucher.value.trim() === "FACTURA PROFORMA" ||
        nameVoucher.value.trim() === "PROFORMA" ||
        nameVoucher.value.trim() === "TICKET" ||
        nameVoucher.value.trim() === "PROFORMA DE VENTA" ||
        nameVoucher.value.trim() === "REGIMENES ESPECIAL" ||
        nameVoucher.value.trim() === "REGIMEN ESPECIAL" ||
        nameVoucher.value.trim() === "REGIMENES ESPECIALES" ||
        nameVoucher.value.trim() === "REGÍMENES ESPECIALES" ||
        nameVoucher.value.trim() === "COTIZACIÓN" ||
        nameVoucher.value.trim() === "COTIZACION" ||
        nameVoucher.value.trim() === "COTIZACIONES" ||
        nameVoucher.value.trim() === "PEDIDO" ||
        nameVoucher.value.trim() === "PEDIDO CLIENTE" ||
        nameVoucher.value.trim() === "FACTURA HOLD" ||
        nameVoucher.value.trim() === "FACTURAS HOLD" ||
        nameVoucher.value.trim() === "FACTURA OLD" ||
        nameVoucher.value.trim() === "FACTURAS OLD"
      ) {
        /*********************************************************************************
         * Si la venta es a credito validamos que haya ingresado le fecha de pago
         *********************************************************************************/
        if (dataForm.value.idTypeOfSale !== 1) {
          if (
            dataForm.value.paymentDate === null ||
            dataForm.value.paymentDate === undefined
          ) {
            errorActions(
              "Lo sentimos no podemos realizar la venta debido a que no has seleccionado la fecha de pago de la venta a crédito"
            );
            spinner.value = false;
            return;
          }
        }

        /*********************************************************************************
         * Llamamos al comprobante y obtenemos sus datos
         *********************************************************************************/
        const { id, numberCurrent, serie, printFormat } =
          await voucherSales(dataForm.value.idVoucher);

        typePrintVoucher.value = printFormat;
        dataForm.value.idVoucher = id;
        dataForm.value.numberVoucher = numberCurrent;
        dataForm.value.serieVoucher = serie;
      }

      /*********************************************************************************
       * Validaciones obligatorias antes de realizar la venta
       *********************************************************************************/
      await getFullNameCustomer();
      await assignAmountToPaymentType();
      if (dataForm.value.customerName.length <= 2) {
        errorActions(
          "Por favor ingresa el nombre del cliente y vuelve a intentarlo de nuevo"
        );
        spinner.value = false;
        return;
      }

      if (await validateStateForInsurer()) {
        errorActions(
          "Hay un producto que tiene un descuento por seguro, por favor selecciona un aseguradora y vuelve a intentarlo"
        );
        spinner.value = false;
        return;
      }

      if (
        nameVoucher.value.trim() !== "PEDIDO" &&
        nameVoucher.value.trim() !== "PEDIDO CLIENTE" &&
        nameVoucher.value.trim() !== "FACTURA HOLD" &&
        nameVoucher.value.trim() !== "FACTURAS HOLD" &&
        nameVoucher.value.trim() !== "FACTURA OLD" &&
        nameVoucher.value.trim() !== "FACTURAS OLD" &&
        !isQuotationVoucher(nameVoucher.value)
      ) {
        if (dataForm.value.idTypeOfSale === 1) {
          if (dataForm.value.idTypeOfPayment === 1) {
            if (
              dataForm.value.customerAmountPaid <
              dataForm.value.totalWhitDiscount
            ) {
              errorActions(
                "Por favor ingresa el monto con lo que esta pagando el cliente y vuelve a intentarlo de nuevo"
              );
              spinner.value = false;
              return;
            }
          }
          if (dataForm.value.idTypeOfPayment === 5) {
            const total =
              parseFloat(dataForm.value.cashAmount) +
              parseFloat(dataForm.value.targetAmount) +
              parseFloat(dataForm.value.transferAmount) +
              parseFloat(dataForm.value.chequeAmount);
            if (total < dataForm.value.totalWhitDiscount) {
              errorActions(
                "Ud tiene seleccionado la opcion de pago combinado y al parecer no a ingresado ningun valor, por favor seleccione nuevamente el tipo de pago e ingrese su monto."
              );
              spinner.value = false;
              return;
            }
          }
        } else {
          //Mandamos a llamar la funcion para saber si el cliente aun puede hacer un compra a credito
          if (!(await checkTotalCustomerCredit())) {
            return;
          }
          normalizeCreditInitialPaymentAmounts();
        }
      }
      if (arrayOfProducts.value.length <= 0) {
        errorActions(
          "Por favor agrega unos productos a la lista de ventas y vuelve a intentarlo de nuevo."
        );
        spinner.value = false;
        return;
      }

      /*********************************************************************************
       * Insertar la venta
       *********************************************************************************/
      if (
        nameVoucher.value.trim() === "FACTURA ELECTRONICA" ||
        nameVoucher.value.trim() === "FACTURA ELECTRÓNICA" ||
        nameVoucher.value.trim() === "NOTA DE VENTA" ||
        nameVoucher.value.trim() === "BOLETA ELECTRÓNICA" ||
        nameVoucher.value.trim() === "BOLETA ELECTRONICA" ||
        nameVoucher.value.trim() === "BOLETA" ||
        nameVoucher.value.trim() === "FACTURA" ||
        nameVoucher.value.trim() === "FACTURA PARA CREDITO FISCAL" ||
        nameVoucher.value.trim() === "FACTURA PARA CONSUMO" ||
        nameVoucher.value.trim() === "COMPROBANTE GUBERNAMENTAL" ||
        nameVoucher.value.trim() === "FACTURA PROFORMA" ||
        nameVoucher.value.trim() === "PROFORMA" ||
        nameVoucher.value.trim() === "TICKET" ||
        nameVoucher.value.trim() === "PROFORMA DE VENTA" ||
        nameVoucher.value.trim() === "REGIMENES ESPECIAL" ||
        nameVoucher.value.trim() === "REGIMENES ESPECIALES" ||
        nameVoucher.value.trim() === "REGÍMENES ESPECIALES" ||
        nameVoucher.value.trim() === "REGIMEN ESPECIAL"
      ) {
        /*********************************************************************************
         * Antes de llamar al numero del comprobante, general la venta, etc.
         * Tenemos que verificar el estado de la caja
         *********************************************************************************/
        const stateBox = await validateBoxe();
        if (stateBox === false) {
          errorActions(
            "Por favor <strong>apertura la caja</strong> para poder realizar la emision de la venta"
          );
          spinner.value = false;
          return;
        }

        /*********************************************************************************
         * Llamamos al numero de referencia para obtener sus valores
         *********************************************************************************/
        const { idReferenceNumber, referenceNumberCurrent } =
          await referenceNumber();
        dataForm.value.numberReference = referenceNumberCurrent;

        //Insertamos la venta
        const { id: salesRecord, numberVoucher, serieVoucher } = await insertSale(
          dataForm.value,
          arrayOfProducts.value,
          infoCustomer.value,
          infoInsurer.value,
          infoOrders.value,
          infoCreditNote.value
        );
        //validamos si la venta se inserto
        if (salesRecord !== undefined || salesRecord !== null) {
          if (parseInt(salesRecord) > 0) {
            if (numberVoucher) {
              dataForm.value.numberVoucher = numberVoucher;
            }
            if (serieVoucher) {
              dataForm.value.serieVoucher = serieVoucher;
            }
            //Actualizamos el numero de referencia
            await updateReferenceNumber(
              idReferenceNumber,
              referenceNumberCurrent
            );
            if (typePrintVoucher.value === "formato_a4") {
              printVoucherOnA4(salesRecord);
            } else if (typePrintVoucher.value === "formato_8x11") {
              printVoucherOnLetter(salesRecord);
            } else if (typePrintVoucher.value === "formato_media_carta") {
              printVoucherOnMediaLetter(salesRecord);
            } else if (typePrintVoucher.value === "formato_ticket") {
              printVoucherTicket(salesRecord);
            }
            //Limpiamos los imputs para la nueva venta
            await cancelSale();
            spinner.value = false;
            return; //Retornamos para no llegar a venta temporales
          } else {
            spinner.value = false;
            return; //Retornamos para no llegar a venta temporales
          }
        } else {
          spinner.value = false;
          return; //Retornamos para no llegar a venta temporales
        }
      }

      /*********************************************************************************
       * Insertar el pedido cliente
       *********************************************************************************/
      if (
        nameVoucher.value.trim() === "PEDIDO" ||
        nameVoucher.value.trim() === "PEDIDO CLIENTE" ||
        nameVoucher.value.trim() === "FACTURA HOLD" ||
        nameVoucher.value.trim() === "FACTURAS HOLD" ||
        nameVoucher.value.trim() === "FACTURA OLD" ||
        nameVoucher.value.trim() === "FACTURAS OLD"
      ) {
        const wasInsert = await insertCustomerOrder(
          dataForm.value,
          arrayOfProducts.value,
          infoCustomer.value
        );
        if (wasInsert !== undefined || wasInsert !== null) {
          //Actualizamos los datos del comprobantes
          await updateNumberVoucher(
            dataForm.value.idVoucher,
            dataForm.value.numberVoucher
          );
          //Limpiamos los imputs para la nueva venta
          await cancelSale();
          return; //Retornamos para no llegar a venta temporales
        }
        return;
      }

      /*********************************************************************************
       * Insertar la cotización del cliente
       *********************************************************************************/
      if (isQuotationVoucher(nameVoucher.value)) {
        const wasInsert = await insertQuotes(
          dataForm.value,
          arrayOfProducts.value,
          infoCustomer.value,
          idOrderQuot.value
        );
        if (wasInsert !== undefined || wasInsert !== null) {
          //Actualizamos los datos del comprobantes
          await updateNumberVoucher(
            dataForm.value.idVoucher,
            dataForm.value.numberVoucher
          );
          if (typePrintVoucher.value === "formato_a4") {
            printOnA4(wasInsert);
          } else if (typePrintVoucher.value === "formato_8x11") {
            printOnLetter(wasInsert);
          } else if (typePrintVoucher.value === "formato_media_carta") {
            printOnMediaLetter(wasInsert);
          } else if (typePrintVoucher.value === "formato_ticket") {
            printOnTicket(wasInsert);
          }
          //Limpiamos los imputs para la nueva venta
          await cancelSale();
          return; //Retornamos para no llegar a venta temporales
        }
        return;
      }
    };

    let handleKeydown;
    let refreshSpecificAccesses;
    const KEYDOWN = () => {
      const focusElement = (id, { select = false } = {}) => {
        const element = document.getElementById(id);
        if (!element || typeof element.focus !== "function") {
          return;
        }

        element.focus();
        if (select && typeof element.select === "function") {
          element.select();
        }
      };

      handleKeydown = async (event) => {
        if (event.altKey && event.key.toLowerCase() === "c") {
          event.preventDefault();
          focusElement("inputCustomer");
        }
        if (event.altKey && event.key.toLowerCase() === "p") {
          event.preventDefault();
          focusElement("searchInputProduct");
        }
        if (event.altKey && event.key.toLowerCase() === "x") {
          event.preventDefault();
          await cancelSale();
        }
        if (event.altKey && event.key.toLowerCase() === "s") {
          event.preventDefault();
          await insert();
        }
        if (event.altKey && event.key.toLowerCase() === "d") {
          event.preventDefault();
          focusElement("import_payments", { select: true });
        }
      };
      document.addEventListener("keydown", handleKeydown);
      focusElement("searchInputProduct");
    };

    onMounted(async () => {
      observeElement("#containtSales");
      observeElement("#dataTable");

      dataForm.value.idStore = await idLocalStore();
      dataForm.value.idUser = await idLocalUser();
      dataForm.value.idTurn = await idLocalTurn();
      dataForm.value.userName = await localUserName();
      dataForm.value.igvApplied = await localIVA();
      const currency = await localMoney();
      dataForm.value.currencyDescription = currency.currency;
      dataForm.value.currencyPrefix = currency.prefix;

      await syncSalesSpecificAccesses();

      refreshSpecificAccesses = async () => {
        if (typeof document !== "undefined" && document.hidden) {
          return;
        }

        await syncSalesSpecificAccesses();
      };

      window.addEventListener("focus", refreshSpecificAccesses);
      document.addEventListener("visibilitychange", refreshSpecificAccesses);

      adjustTableSize();
      KEYDOWN();
    });
    onUnmounted(() => {
      if (refreshSpecificAccesses) {
        window.removeEventListener("focus", refreshSpecificAccesses);
        document.removeEventListener("visibilitychange", refreshSpecificAccesses);
      }

      document.removeEventListener("keydown", handleKeydown);
    });

    /*********************************************************************************
     * Funcion para guardar un venta temporal
     *********************************************************************************/
    const saveTemporarySales = async () => {
      /*********************************************************************************
       * Validaciones obligatorias antes de realizar la venta
       *********************************************************************************/
      await getFullNameCustomer();
      if (dataForm.value.customerName.length <= 2) {
        errorActions(
          "Por favor ingresa el nombre del cliente y vuelve a intentarlo de nuevo"
        );
        spinner.value = false;
        return;
      }
      if (arrayOfProducts.value.length <= 0) {
        errorActions(
          "Por favor agrega unos productos a la lista de ventas y vuelve a intentarlo de nuevo."
        );
        spinner.value = false;
        return;
      }
      /*********************************************************************************
       * Insertar ventas temporales
       *********************************************************************************/
      const wasInsert = await insertTemporarySale(
        dataForm.value,
        arrayOfProducts.value,
        infoCustomer.value
      );
      if (wasInsert !== undefined || wasInsert !== null) {
        //Limpiamos los imputs para la nueva venta
        await cancelSale();
      }
    };
    const adjustTableSize = () => {
      const table = document.querySelector(".table-d");
      const menu = document.querySelector(".grid-cols-2-small");
      if (table && menu) {
        table.style.width = `${menu.offsetWidth - 40}px`;
        table.style.overflowX = "scroll";
      }
    };

    const mediaQuery = window.matchMedia("(max-width: 700px)");
    if (mediaQuery.matches) {
      adjustTableSize();
    }

    window.addEventListener("resize", () => {
      if (mediaQuery.matches) {
        adjustTableSize();
      }
    });
    return {
      salesMainPanel,
      getSelectTypeOfPayment,
      getSelectTypeOfSale,
      getSelectVouchersOfSale,
      dataForm,
      stateForPaymentType,
      stateForSaleType,
      stateForQuotation,
      spinner,
      showTemporarySales,
      stateTemporarySales,
      header,
      loading,
      money,
      format,
      stateSalesHold,
      showSalesHold,
      getDataCustomer,
      getDataAppDelivery,
      stateAppDelivery,
      showAppDelivery,
      addProducts,
      searchedProductLocation,
      deleteRecordFromTable,
      arrayOfProducts,
      handleQuantityChange,
      handleInsuranceDiscountChange,
      handleDiscountChange,
      handleUnitMeasureChange,
      stateAddProduct,
      showAddProduct,
      getAmountAgreed,
      cancelSale,
      getInsurer,
      stateInsurer,
      showInsurer,
      infoInsurer,
      showValidateUserAccess,
      validateAccess,
      stateShowUserAccess,
      salesDiscountStatus,
      area,
      applyDiscountToSale,
      insert,
      showCombinedPayments,
      stateShowCombinedPayment,
      getCombinedPayment,
      calculteCustomerAmountReturned,
      stateInputsThePayment,
      stateShowInfoCustomer,
      saveTemporarySales,
      stateForCreditToSale,
      getOrder,
      showQuotes,
      stateQuotes,
      getCreditNote,
      stateCreditNote,
      showCreditNote,
      stateAccesInsurer,
      stateAccesWorkshopEquipments,
      stateModifiPrice,
      nameVoucher,
      primaryActionLabel,
      primaryActionLoadingLabel,
      handeCharge,
      handlePriceForDiscount,
      calculateOffertExpired,
      handleProductSerie,
      handleUnitPriceChange,
      changeVoucher,
      customerSearchKey,
      typeVoucher,
      counterKeyTypeOfPayment,
      counterKeyTypeOfSale,
      selectProduct,
      handlePrices,
      infoCustomer,
      usePriceTwo,
      usePriceThree,
      stateAccesCheck,
      stateAccesPSerie,
      productsOutOfStock,
      showModalProductsOutStock,
      isShowModalProductsOutStock,
      statePurchaseHistoryModal,
      purchaseHistorySales,
      purchaseHistoryLoading,
      purchaseHistoryError,
      openPurchaseHistory,
      closePurchaseHistory,
      workshopCustomerName,
      prefilledCustomerData,
      stateWorkshopEquipments,
      showWorkshopEquipments,
      closeWorkshopEquipments,
      selectedWorkshopOrder,
      applyWorkshopOrderSelection,
    };
  },
};
</script>
<style scoped>
.scroll-options-sales::-webkit-scrollbar {
  height: 0.3rem;
  width: 0.3rem;
  border-radius: 0.5rem;
  background-color: rgb(0 0 0 /10%);
}

.scroll-options-sales::-webkit-scrollbar-thumb {
  border-radius: 0.5rem;
  background-color: #17223a69;
}

.scroll-options-sales::-webkit-scrollbar-thumb:active,
.scroll-options-sales::-webkit-scrollbar-thumb:hover {
  background-color: #0453ffc9;
}

.scroll-options-sales::-webkit-scrollbar-track {
  border-radius: 0.5rem;
  background-color: #49638517;
}

.location-badge {
  animation: locationBadgeReveal 0.45s ease-out;
}

@keyframes locationBadgeReveal {
  0% {
    opacity: 0;
    transform: translateY(8px) scale(0.98);
    box-shadow: 0 0 0 rgba(14, 116, 144, 0);
  }

  65% {
    opacity: 1;
    transform: translateY(0) scale(1.01);
    box-shadow: 0 8px 18px rgba(14, 116, 144, 0.16);
  }

  100% {
    opacity: 1;
    transform: translateY(0) scale(1);
    box-shadow: 0 4px 10px rgba(14, 116, 144, 0.1);
  }
}
</style>
